// import { useEffect, useState } from "react";
// import { motion } from "framer-motion";
// import { Code, Smartphone, Globe, Zap, ArrowRight, MessageCircle } from "lucide-react";

// const images = [
//   {
//     url: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=702&auto=format&fit=crop",
//     alt: "Modern Website Design",
//   },
//   {
//     url: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=702&auto=format&fit=crop",
//     alt: "Responsive Website",
//   },
// ];

// export const HeroSection = () => {
//   const [isSwapped, setIsSwapped] = useState(false);
//   const [isHovered, setIsHovered] = useState(false);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setIsSwapped((prev) => !prev);
//     }, 5000);
//     return () => clearInterval(interval);
//   }, []);

//   const topImage = isSwapped ? images[1] : images[0];
//   const bottomImage = isSwapped ? images[0] : images[1];

//   return (
//     <section
//       className="relative min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-emerald-900 px-6 md:px-16 text-white flex items-center justify-center overflow-hidden"
//     >
//       {/* Animated background elements */}
//       <div className="absolute inset-0 overflow-hidden">
//         {[...Array(15)].map((_, i) => (
//           <motion.div
//             key={i}
//             className="absolute rounded-full bg-emerald-500/10"
//             style={{
//               top: `${Math.random() * 100}%`,
//               left: `${Math.random() * 100}%`,
//               width: `${Math.random() * 300 + 50}px`,
//               height: `${Math.random() * 300 + 50}px`,
//             }}
//             animate={{
//               scale: [1, 1.2, 1],
//               rotate: [0, 180, 360],
//             }}
//             transition={{
//               duration: Math.random() * 10 + 10,
//               repeat: Infinity,
//               ease: "linear",
//             }}
//           />
//         ))}

//       </div>

//       <div className="relative z-10 max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-16 w-full py-12">
//         {/* Left Text */}
//         <motion.div
//           initial={{ opacity: 0, x: -60 }}
//           whileInView={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.8 }}
//           viewport={{ once: false }}
//           className="text-center md:text-left md:w-1/2"
//         >
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.2, duration: 0.6 }}
//             viewport={{ once: false }}
//             className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6"
//           >
//             <Zap className="w-4 h-4 text-emerald-400" />
//             <span className="text-sm">Full Stack Developer</span>
//           </motion.div>

//           <h1 className="text-5xl md:text-6xl font-bold leading-tight mb-6">
//             Transforming Ideas Into{" "}
//             <span className="bg-gradient-to-r from-emerald-400 to-blue-500 bg-clip-text text-transparent">
//               Digital Excellence
//             </span>
//           </h1>

//           <motion.p
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.4, duration: 0.6 }}
//             viewport={{ once: false }}
//             className="text-lg md:text-xl text-gray-300 max-w-xl mx-auto md:mx-0 mb-8"
//           >
//             Hi, I'm <strong className="text-white">Momin Hussain</strong> – a passionate Full stack web developer crafting high-performance, responsive websites that drive business growth and deliver exceptional user experiences.
//           </motion.p>

//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.6, duration: 0.6 }}
//             viewport={{ once: false }}
//             className="flex flex-wrap justify-center md:justify-start gap-4 mb-10"
//           >
//             {[
//               { icon: <Code className="w-5 h-5" />, text: "Web Development" },
//               { icon: <Smartphone className="w-5 h-5" />, text: "Mobile Responsive" },
//               { icon: <Globe className="w-5 h-5" />, text: "SEO Optimized" },
//             ].map((item, index) => (
//               <div key={index} className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg">
//                 {item.icon}
//                 <span className="text-sm">{item.text}</span>
//               </div>
//             ))}
//           </motion.div>

//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.8, duration: 0.6 }}
//             viewport={{ once: false }}
//             className="flex flex-wrap justify-center md:justify-start gap-4"
//           >
//             <motion.a
//               href="https://wa.me/923112891862?text=Hi%20Momin%2C%20I%20want%20to%20discuss%20a%20project"
//               target="_blank"
//               rel="noopener noreferrer"
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               onMouseEnter={() => setIsHovered(true)}
//               onMouseLeave={() => setIsHovered(false)}
//               className="flex items-center gap-2 bg-gradient-to-r from-blue-600 to-emerald-600 hover:from-blue-700 hover:to-emerald-700 text-white px-8 py-4 rounded-xl shadow-lg hover:shadow-blue-500/30 transition-all duration-300 font-medium"
//             >
//               <MessageCircle className="w-5 h-5" />
//               Start a Conversation
//               <motion.div
//                 animate={{ x: isHovered ? 5 : 0 }}
//                 transition={{ type: "spring", stiffness: 500 }}
//               >
//                 <ArrowRight className="w-5 h-5" />
//               </motion.div>
//             </motion.a>

//             <motion.a
//               href="#portfolio"
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               className="flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-xl border border-white/20 transition-all duration-300 font-medium"
//             >
//               View My Work
//             </motion.a>
//           </motion.div>
//         </motion.div>

//         {/* Right Images */}
//         <motion.div 
//           className="relative w-[280px] sm:w-[320px] md:w-[400px] aspect-[3/4] mx-auto"
//           initial={{ opacity: 0, x: 60 }}
//           whileInView={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.8, delay: 0.5 }}
//           viewport={{ once: false }}
//         >
//           <motion.div
//             key={topImage.url}
//             initial={{ opacity: 0, y: -20, rotate: -5 }}
//             animate={{ opacity: 1, y: 0, rotate: 0 }}
//             transition={{ duration: 0.8 }}
//             className="absolute top-0 left-0 w-full h-full rounded-3xl overflow-hidden shadow-2xl border-4 border-emerald-500/50 z-20"
//           >
//             <img
//               src={topImage.url}
//               alt={topImage.alt}
//               className="w-full h-full object-cover"
//             />
//             <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
//               <div className="text-white">
//                 <h3 className="font-bold">Modern Design</h3>
//                 <p className="text-sm">Clean & Professional</p>
//               </div>
//             </div>
//           </motion.div>

//           <motion.div
//             key={bottomImage.url + "-blur"}
//             initial={{ opacity: 0, y: 20, rotate: 5 }}
//             animate={{ opacity: 1, y: 0, rotate: 0 }}
//             transition={{ duration: 0.8 }}
//             className="absolute -bottom-8 -right-8 w-full h-full rounded-3xl overflow-hidden border-4 border-white/30 opacity-80 blur-[2px] z-10"
//           >
//             <img
//               src={bottomImage.url}
//               alt={bottomImage.alt}
//               className="w-full h-full object-cover scale-95"
//             />
//           </motion.div>

//           {/* Floating elements */}
//           <motion.div
//             className="absolute -top-6 -left-6 bg-emerald-500 text-white p-3 rounded-xl shadow-lg z-30"
//             animate={{ y: [0, -10, 0] }}
//             transition={{ duration: 3, repeat: Infinity }}
//           >
//             <Zap className="w-5 h-5" />
//           </motion.div>

//           <motion.div
//             className="absolute -bottom-4 -left-10 bg-blue-500 text-white p-3 rounded-xl shadow-lg z-30"
//             animate={{ y: [0, 10, 0] }}
//             transition={{ duration: 4, repeat: Infinity, delay: 1 }}
//           >
//             <Globe className="w-5 h-5" />
//           </motion.div>
//         </motion.div>
//       </div>

//       {/* Scroll indicator */}
//       <motion.div
//         className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
//         animate={{ y: [0, 10, 0] }}
//         transition={{ duration: 2, repeat: Infinity }}
//       >
//         <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
//           <motion.div
//             className="w-1 h-3 bg-white rounded-full mt-2"
//             animate={{ y: [0, 12, 0] }}
//             transition={{ duration: 2, repeat: Infinity }}
//           />
//         </div>
//       </motion.div>
//     </section>
//   );
// };

// import { useEffect, useState } from "react";
// import { motion } from "framer-motion";
// import { Code, Smartphone, Globe, Zap, ArrowRight, MessageCircle, Box, Sparkles, Cpu } from "lucide-react";

// export const HeroSection = () => {
//   const [isHovered, setIsHovered] = useState(false);
//   const [rotation, setRotation] = useState({ x: 0, y: 0 });

//   // Handle mouse move for 3D effect
//   const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
//     const rect = e.currentTarget.getBoundingClientRect();
//     const x = e.clientX - rect.left;
//     const y = e.clientY - rect.top;

//     const centerX = rect.width / 2;
//     const centerY = rect.height / 2;

//     const rotateX = (y - centerY) / 20;
//     const rotateY = (centerX - x) / 20;

//     setRotation({ x: rotateX, y: rotateY });
//   };

//   const handleMouseLeave = () => {
//     setRotation({ x: 0, y: 0 });
//   };

//   return (
//     <section
//       className="relative min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-emerald-900 px-6 md:px-16 text-white flex items-center justify-center overflow-hidden"
//     >
//       {/* Animated background elements */}
//       <div className="absolute inset-0 overflow-hidden">
//         {[...Array(15)].map((_, i) => (
//           <motion.div
//             key={i}
//             className="absolute rounded-full bg-emerald-500/10"
//             style={{
//               top: `${Math.random() * 100}%`,
//               left: `${Math.random() * 100}%`,
//               width: `${Math.random() * 300 + 50}px`,
//               height: `${Math.random() * 300 + 50}px`,
//             }}
//             animate={{
//               scale: [1, 1.2, 1],
//               rotate: [0, 180, 360],
//             }}
//             transition={{
//               duration: Math.random() * 10 + 10,
//               repeat: Infinity,
//               ease: "linear",
//             }}
//           />
//         ))}
//       </div>

//       <div className="relative z-10 max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-16 w-full py-12">
//         {/* Left Text */}
//         <motion.div
//           initial={{ opacity: 0, x: -60 }}
//           whileInView={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.8 }}
//           viewport={{ once: false }}
//           className="text-center md:text-left md:w-1/2"
//         >
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.2, duration: 0.6 }}
//             viewport={{ once: false }}
//             className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6"
//           >
//             <Zap className="w-4 h-4 text-emerald-400" />
//             <span className="text-sm">Full Stack Developer</span>
//           </motion.div>

//           <h1 className="text-5xl md:text-6xl font-bold leading-tight mb-6">
//             Transforming Ideas Into{" "}
//             <span className="bg-gradient-to-r from-emerald-400 to-blue-500 bg-clip-text text-transparent">
//               Digital Excellence
//             </span>
//           </h1>

//           <motion.p
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.4, duration: 0.6 }}
//             viewport={{ once: false }}
//             className="text-lg md:text-xl text-gray-300 max-w-xl mx-auto md:mx-0 mb-8"
//           >
//             Hi, I'm <strong className="text-white">Momin Hussain</strong> – a passionate Full stack web developer crafting high-performance, responsive websites that drive business growth and deliver exceptional user experiences.
//           </motion.p>

//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.6, duration: 0.6 }}
//             viewport={{ once: false }}
//             className="flex flex-wrap justify-center md:justify-start gap-4 mb-10"
//           >
//             {[
//               { icon: <Code className="w-5 h-5" />, text: "Web Development" },
//               { icon: <Smartphone className="w-5 h-5" />, text: "Mobile Responsive" },
//               { icon: <Globe className="w-5 h-5" />, text: "SEO Optimized" },
//             ].map((item, index) => (
//               <div key={index} className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg">
//                 {item.icon}
//                 <span className="text-sm">{item.text}</span>
//               </div>
//             ))}
//           </motion.div>

//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.8, duration: 0.6 }}
//             viewport={{ once: false }}
//             className="flex flex-wrap justify-center md:justify-start gap-4"
//           >
//             <motion.a
//               href="https://wa.me/923112891862?text=Hi%20Momin%2C%20I%20want%20to%20discuss%20a%20project"
//               target="_blank"
//               rel="noopener noreferrer"
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               onMouseEnter={() => setIsHovered(true)}
//               onMouseLeave={() => setIsHovered(false)}
//               className="flex items-center gap-2 bg-gradient-to-r from-blue-600 to-emerald-600 hover:from-blue-700 hover:to-emerald-700 text-white px-8 py-4 rounded-xl shadow-lg hover:shadow-blue-500/30 transition-all duration-300 font-medium"
//             >
//               <MessageCircle className="w-5 h-5" />
//               Start a Conversation
//               <motion.div
//                 animate={{ x: isHovered ? 5 : 0 }}
//                 transition={{ type: "spring", stiffness: 500 }}
//               >
//                 <ArrowRight className="w-5 h-5" />
//               </motion.div>
//             </motion.a>

//             <motion.a
//               href="#portfolio"
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               className="flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-xl border border-white/20 transition-all duration-300 font-medium"
//             >
//               View My Work
//             </motion.a>
//           </motion.div>
//         </motion.div>

//         {/* Right Side - 3D Element */}
//         <motion.div
//           className="relative w-[350px] sm:w-[400px] md:w-[480px] aspect-square mx-auto"
//           initial={{ opacity: 0, x: 60 }}
//           whileInView={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.8, delay: 0.5 }}
//           viewport={{ once: false }}
//           onMouseMove={handleMouseMove}
//           onMouseLeave={handleMouseLeave}
//           style={{
//             transformStyle: "preserve-3d",
//             perspective: "1200px",
//           }}
//         >
//           {/* Main 3D Cube Container */}
//           <motion.div
//             className="relative w-full h-full"
//             animate={{
//               rotateX: rotation.x,
//               rotateY: rotation.y,
//             }}
//             transition={{ type: "spring", stiffness: 150, damping: 15 }}
//             style={{
//               transformStyle: "preserve-3d",
//             }}
//           >
//             {/* Front Face - Developer Showcase */}
//             <div className="absolute inset-0 backface-hidden">
//               <div className="relative w-full h-full bg-gradient-to-br from-indigo-600/30 via-purple-600/30 to-pink-600/30 backdrop-blur-xl rounded-[40px] border-2 border-white/30 shadow-2xl flex items-center justify-center overflow-hidden">

//                 {/* Animated background patterns */}
//                 <div className="absolute inset-0">
//                   <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(255,255,255,0.3)_0%,transparent_40%)]" />
//                   <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_80%,rgba(255,255,255,0.3)_0%,transparent_40%)]" />
//                   <div className="absolute inset-0" style={{
//                     backgroundImage: `repeating-linear-gradient(45deg, rgba(255,255,255,0.1) 0px, rgba(255,255,255,0.1) 2px, transparent 2px, transparent 10px)`,
//                   }} />
//                 </div>

//                 {/* Floating orbs - colorful */}
//                 <motion.div
//                   className="absolute w-48 h-48 bg-blue-500/40 rounded-full blur-3xl top-5 left-5"
//                   animate={{
//                     scale: [1, 1.4, 1],
//                     x: [0, 30, 0],
//                     y: [0, -20, 0],
//                   }}
//                   transition={{ duration: 7, repeat: Infinity }}
//                 />
//                 <motion.div
//                   className="absolute w-56 h-56 bg-purple-500/40 rounded-full blur-3xl bottom-5 right-5"
//                   animate={{
//                     scale: [1, 1.5, 1],
//                     x: [0, -30, 0],
//                     y: [0, 30, 0],
//                   }}
//                   transition={{ duration: 8, repeat: Infinity }}
//                 />
//                 <motion.div
//                   className="absolute w-40 h-40 bg-pink-500/40 rounded-full blur-3xl top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
//                   animate={{
//                     scale: [1, 1.3, 1],
//                     opacity: [0.4, 0.7, 0.4],
//                   }}
//                   transition={{ duration: 6, repeat: Infinity }}
//                 />

//                 {/* Main Content */}
//                 <div className="relative z-20 w-full h-full flex flex-col items-center justify-center p-8">

//                   {/* 3D Rotating Icon Sphere - Main Attraction */}
//                   <motion.div
//                     animate={{
//                       rotateY: [0, 360],
//                       rotateX: [0, 15, 0, -15, 0],
//                     }}
//                     transition={{
//                       rotateY: { duration: 20, repeat: Infinity, ease: "linear" },
//                       rotateX: { duration: 8, repeat: Infinity, ease: "easeInOut" },
//                     }}
//                     className="relative mb-6"
//                   >
//                     {/* Glowing rings */}
//                     <div className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-500 via-purple-500 emerald-400 blur-3xl opacity-60" />

//                     {/* Main icon container - Bigger */}
//                     <div className="relative w-56 h-56">
//                       {/* Outer rotating ring - gradient border */}
//                       <motion.div
//                         className="absolute inset-0 rounded-full border-4 border-transparent"
//                         style={{
//                           background: "linear-gradient(135deg, #3B82F6, #A855F7, #EC4899)",
//                           WebkitMask: "linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0)",
//                           WebkitMaskComposite: "destination-out",
//                           maskComposite: "exclude",
//                         }}
//                         animate={{ rotate: 360 }}
//                         transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
//                       />

//                       {/* Middle ring */}
//                       <motion.div
//                         className="absolute inset-3 rounded-full border-2 border-dashed border-white/40"
//                         animate={{ rotate: -360 }}
//                         transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
//                       />

//                       {/* Inner ring with particles */}
//                       <div className="absolute inset-6 rounded-full bg-gradient-to-br from-blue-600/20 via-purple-600/20 to-pink-600/20 backdrop-blur-sm border border-white/30 shadow-xl flex items-center justify-center overflow-hidden">

//                         {/* Floating particles */}
//                         {[...Array(8)].map((_, i) => (
//                           <motion.div
//                             key={i}
//                             className="absolute w-2 h-2 rounded-full"
//                             style={{
//                               background: i % 3 === 0 ? '#3B82F6' : i % 3 === 1 ? '#A855F7' : '#EC4899',
//                               top: `${Math.random() * 100}%`,
//                               left: `${Math.random() * 100}%`,
//                             }}
//                             animate={{
//                               y: [0, -40, 0],
//                               x: [0, i % 2 === 0 ? 20 : -20, 0],
//                               opacity: [0, 1, 0],
//                               scale: [0, 1.5, 0],
//                             }}
//                             transition={{
//                               duration: 3 + i,
//                               repeat: Infinity,
//                               delay: i * 0.3,
//                             }}
//                           />
//                         ))}

//                         {/* Central Developer Icon - Custom SVG */}
//                         <svg viewBox="0 0 120 120" className="w-32 h-32 z-10">
//                           <defs>
//                             <linearGradient id="devGrad" x1="0%" y1="0%" x2="100%" y2="100%">
//                               <stop offset="0%" stopColor="#3B82F6">
//                                 <animate attributeName="stop-color" values="#3B82F6; #A855F7; #EC4899; #3B82F6" dur="5s" repeatCount="indefinite" />
//                               </stop>
//                               <stop offset="50%" stopColor="#A855F7">
//                                 <animate attributeName="stop-color" values="#A855F7; #EC4899; #3B82F6; #A855F7" dur="5s" repeatCount="indefinite" />
//                               </stop>
//                               <stop offset="100%" stopColor="#EC4899">
//                                 <animate attributeName="stop-color" values="#EC4899; #3B82F6; #A855F7; #EC4899" dur="5s" repeatCount="indefinite" />
//                               </stop>
//                             </linearGradient>
//                             <filter id="glow">
//                               <feGaussianBlur stdDeviation="3" result="coloredBlur" />
//                               <feMerge>
//                                 <feMergeNode in="coloredBlur" />
//                                 <feMergeNode in="SourceGraphic" />
//                               </feMerge>
//                             </filter>
//                           </defs>

//                           {/* Developer silhouette with laptop */}
//                           <g filter="url(#glow)">
//                             {/* Head */}
//                             <circle cx="60" cy="35" r="12" fill="url(#devGrad)" fillOpacity="0.8" />

//                             {/* Body */}
//                             <rect x="48" y="45" width="24" height="30" fill="url(#devGrad)" fillOpacity="0.6" rx="4" />

//                             {/* Laptop base */}
//                             <rect x="30" y="75" width="60" height="8" fill="url(#devGrad)" fillOpacity="0.9" rx="2" />

//                             {/* Laptop screen */}
//                             <rect x="35" y="50" width="50" height="30" fill="none" stroke="url(#devGrad)" strokeWidth="3" rx="3" />

//                             {/* Screen content - code lines */}
//                             <line x1="45" y1="62" x2="75" y2="62" stroke="white" strokeWidth="2" strokeLinecap="round">
//                               <animate attributeName="x2" values="75;70;75" dur="2s" repeatCount="indefinite" />
//                             </line>
//                             <line x1="45" y1="68" x2="65" y2="68" stroke="white" strokeWidth="2" strokeLinecap="round">
//                               <animate attributeName="x2" values="65;60;65" dur="2s" repeatCount="indefinite" begin="0.5s" />
//                             </line>
//                             <line x1="45" y1="74" x2="55" y2="74" stroke="white" strokeWidth="2" strokeLinecap="round">
//                               <animate attributeName="x2" values="55;50;55" dur="2s" repeatCount="indefinite" begin="1s" />
//                             </line>

//                             {/* Floating code symbols */}
//                             <text x="15" y="25" fill="white" fontSize="12" opacity="0.7">&lt;/&gt;</text>
//                             <text x="90" y="90" fill="white" fontSize="12" opacity="0.7">{'{ }'}</text>
//                           </g>
//                         </svg>
//                       </div>
//                     </div>
//                   </motion.div>

//                   {/* Title with animated gradient */}
//                   <motion.h3
//                     initial={{ opacity: 0, y: 20 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ delay: 0.3 }}
//                     className="text-3xl font-black mb-1 text-center"
//                   >
//                     <span className="bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 bg-clip-text text-transparent bg-[length:200%_auto] animate-gradient">
//                       Momin Hussain
//                     </span>
//                   </motion.h3>

//                   <motion.p
//                     initial={{ opacity: 0, y: 20 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ delay: 0.4 }}
//                     className="text-xl font-medium text-white/90 mb-4"
//                   >
//                     Full Stack Developer
//                   </motion.p>

//                   {/* Tech stack badges - animated */}
//                   <motion.div
//                     className="flex flex-wrap justify-center gap-2"
//                     initial={{ opacity: 0, y: 20 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ delay: 0.5 }}
//                   >
//                     {[
//                       { name: 'React', color: 'from-blue-400 to-blue-500' },
//                       { name: 'Node.js', color: 'from-green-400 to-emerald-500' },
//                       { name: 'Python', color: 'from-yellow-400 to-orange-500' },
//                       { name: 'TypeScript', color: 'from-blue-500 to-indigo-500' },
//                       { name: 'Next.js', color: 'from-gray-700 to-gray-900' },
//                       { name: 'MongoDB', color: 'from-green-500 to-teal-500' }
//                     ].map((tech, i) => (
//                       <motion.span
//                         key={tech.name}
//                         className={`px-3 py-1.5 bg-gradient-to-r ${tech.color} text-white text-xs font-semibold rounded-full shadow-lg`}
//                         initial={{ scale: 0 }}
//                         animate={{ scale: 1 }}
//                         transition={{ delay: 0.6 + i * 0.1, type: "spring" }}
//                         whileHover={{ scale: 1.1, y: -2 }}
//                       >
//                         {tech.name}
//                       </motion.span>
//                     ))}
//                   </motion.div>

//                   {/* Experience indicator */}
//                   <motion.div
//                     className="flex items-center gap-4 mt-5"
//                     initial={{ opacity: 0 }}
//                     animate={{ opacity: 1 }}
//                     transition={{ delay: 0.8 }}
//                   >
//                     <div className="flex items-center gap-1">
//                       {[1, 2, 3, 4, 5].map((star) => (
//                         <motion.svg
//                           key={star}
//                           className="w-4 h-4 text-yellow-400"
//                           fill="currentColor"
//                           viewBox="0 0 20 20"
//                           initial={{ scale: 0 }}
//                           animate={{ scale: 1 }}
//                           transition={{ delay: 0.9 + star * 0.1 }}
//                         >
//                           <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//                         </motion.svg>
//                       ))}
//                     </div>
//                     <span className="text-white/80 text-sm">5+ Years Experience</span>
//                   </motion.div>
//                 </div>
//               </div>
//             </div>

//             {/* Back Face - Skills */}
//             <div className="absolute inset-0 backface-hidden" style={{ transform: "rotateY(180deg)" }}>
//               <div className="relative w-full h-full bg-gradient-to-br from-indigo-600/30 via-purple-600/30 to-pink-600/30 backdrop-blur-xl rounded-[40px] border-2 border-white/30 shadow-2xl flex items-center justify-center overflow-hidden p-6">

//                 {/* Background effects */}
//                 <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.2)_0%,transparent_70%)]" />

//                 <div className="relative z-10 text-center">
//                   <motion.h3
//                     className="text-3xl font-bold mb-4 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent"
//                     animate={{ scale: [1, 1.05, 1] }}
//                     transition={{ duration: 3, repeat: Infinity }}
//                   >
//                     Skills & Expertise
//                   </motion.h3>

//                   <div className="grid grid-cols-2 gap-3">
//                     {[
//                       { name: 'Frontend', level: 95 },
//                       { name: 'Backend', level: 90 },
//                       { name: 'Database', level: 85 },
//                       { name: 'DevOps', level: 80 },
//                       { name: 'UI/UX', level: 88 },
//                       { name: 'Mobile', level: 82 }
//                     ].map((skill, i) => (
//                       <motion.div
//                         key={skill.name}
//                         className="bg-white/10 backdrop-blur-sm rounded-xl p-3 border border-white/20"
//                         initial={{ opacity: 0, y: 20 }}
//                         animate={{ opacity: 1, y: 0 }}
//                         transition={{ delay: i * 0.1 }}
//                       >
//                         <div className="text-white font-medium mb-1">{skill.name}</div>
//                         <div className="w-full bg-white/20 rounded-full h-2">
//                           <motion.div
//                             className="h-full rounded-full bg-gradient-to-r from-blue-400 to-purple-400"
//                             initial={{ width: 0 }}
//                             animate={{ width: `${skill.level}%` }}
//                             transition={{ delay: 0.5 + i * 0.1, duration: 1 }}
//                           />
//                         </div>
//                       </motion.div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Right Face - Projects */}
//             <div className="absolute inset-0 backface-hidden" style={{ transform: "rotateY(90deg) translateZ(240px)" }}>
//               <div className="relative w-full h-full bg-gradient-to-br from-indigo-600/30 via-purple-600/30 to-pink-600/30 backdrop-blur-xl rounded-[40px] border-2 border-white/30 shadow-2xl flex items-center justify-center overflow-hidden p-6">

//                 <div className="absolute inset-0 bg-[conic-gradient(from_0deg,rgba(255,255,255,0.1)_0deg,transparent_120deg)]" />

//                 <div className="relative z-10 text-center">
//                   <motion.h3
//                     className="text-3xl font-bold mb-4 bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent"
//                     animate={{ scale: [1, 1.05, 1] }}
//                     transition={{ duration: 3, repeat: Infinity }}
//                   >
//                     Recent Projects
//                   </motion.h3>

//                   <div className="space-y-3">
//                     {[
//                       { name: 'E-Commerce Platform', tech: 'React, Node.js' },
//                       { name: 'AI Analytics Dashboard', tech: 'Python, TensorFlow' },
//                       { name: 'Mobile Banking App', tech: 'React Native' }
//                     ].map((project, i) => (
//                       <motion.div
//                         key={project.name}
//                         className="bg-white/10 backdrop-blur-sm rounded-xl p-3 border border-white/20 text-left"
//                         initial={{ opacity: 0, x: 20 }}
//                         animate={{ opacity: 1, x: 0 }}
//                         transition={{ delay: i * 0.1 }}
//                         whileHover={{ scale: 1.02, backgroundColor: 'rgba(255,255,255,0.2)' }}
//                       >
//                         <div className="text-white font-semibold">{project.name}</div>
//                         <div className="text-white/60 text-sm">{project.tech}</div>
//                       </motion.div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Left Face - Contact */}
//             <div className="absolute inset-0 backface-hidden" style={{ transform: "rotateY(-90deg) translateZ(240px)" }}>
//               <div className="relative w-full h-full bg-gradient-to-br from-indigo-600/30 via-purple-600/30 to-pink-600/30 backdrop-blur-xl rounded-[40px] border-2 border-white/30 shadow-2xl flex items-center justify-center overflow-hidden p-6">

//                 <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,255,255,0.2)_0%,transparent_80%)]" />

//                 <div className="relative z-10 text-center">
//                   <motion.h3
//                     className="text-3xl font-bold mb-4 bg-gradient-to-r from-pink-400 to-orange-400 bg-clip-text text-transparent"
//                     animate={{ scale: [1, 1.05, 1] }}
//                     transition={{ duration: 3, repeat: Infinity }}
//                   >
//                     Let's Connect
//                   </motion.h3>

//                   <div className="space-y-3">
//                     {[
//                       { icon: '📧', text: 'momin@devstack.com' },
//                       { icon: '📱', text: '+92 311 2891862' },
//                       { icon: '💬', text: 'Available for work' }
//                     ].map((item, i) => (
//                       <motion.div
//                         key={item.text}
//                         className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-xl p-3 border border-white/20"
//                         initial={{ opacity: 0, x: -20 }}
//                         animate={{ opacity: 1, x: 0 }}
//                         transition={{ delay: i * 0.1 }}
//                         whileHover={{ scale: 1.02 }}
//                       >
//                         <span className="text-2xl">{item.icon}</span>
//                         <span className="text-white">{item.text}</span>
//                       </motion.div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </motion.div>

//           {/* Floating decorative elements - Colorful */}
//           <motion.div
//             className="absolute -top-8 -right-8 w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-500 rounded-2xl shadow-2xl flex items-center justify-center border-2 border-white/30"
//             animate={{
//               y: [0, -15, 0],
//               rotate: [0, 15, 0],
//               scale: [1, 1.1, 1],
//             }}
//             transition={{ duration: 4, repeat: Infinity }}
//           >
//             <span className="text-white text-2xl">⚡</span>
//           </motion.div>

//           <motion.div
//             className="absolute -bottom-8 -left-8 w-16 h-16 bg-gradient-to-r from-purple-500 emerald-400 rounded-2xl shadow-2xl flex items-center justify-center border-2 border-white/30"
//             animate={{
//               y: [0, 15, 0],
//               rotate: [0, -15, 0],
//               scale: [1, 1.1, 1],
//             }}
//             transition={{ duration: 4, repeat: Infinity, delay: 1 }}
//           >
//             <span className="text-white text-2xl">💻</span>
//           </motion.div>

//           {/* Orbiting icons */}
//           {['🚀', '💡', '✨', '🌟'].map((icon, i) => (
//             <motion.div
//               key={i}
//               className="absolute w-10 h-10 bg-gradient-to-r from-blue-500/50 to-purple-500/50 backdrop-blur-sm rounded-xl flex items-center justify-center border border-white/30 text-xl"
//               animate={{
//                 rotate: [0, 360],
//                 x: [0, Math.cos(i * 90) * 180, 0],
//                 y: [0, Math.sin(i * 90) * 180, 0],
//               }}
//               transition={{
//                 duration: 15,
//                 repeat: Infinity,
//                 delay: i * 2,
//                 ease: "linear",
//               }}
//             >
//               {icon}
//             </motion.div>
//           ))}

//           {/* Floating particles */}
//           {[...Array(10)].map((_, i) => (
//             <motion.div
//               key={i}
//               className="absolute w-1 h-1 rounded-full"
//               style={{
//                 background: i % 3 === 0 ? '#3B82F6' : i % 3 === 1 ? '#A855F7' : '#EC4899',
//                 top: `${Math.random() * 100}%`,
//                 left: `${Math.random() * 100}%`,
//               }}
//               animate={{
//                 y: [0, -30, 0],
//                 x: [0, i % 2 === 0 ? 20 : -20, 0],
//                 scale: [0, 1, 0],
//                 opacity: [0, 1, 0],
//               }}
//               transition={{
//                 duration: 3 + i,
//                 repeat: Infinity,
//                 delay: i * 0.2,
//               }}
//             />
//           ))}
//         </motion.div>
//       </div>

//       {/* Scroll indicator */}
//       <motion.div
//         className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
//         animate={{ y: [0, 10, 0] }}
//         transition={{ duration: 2, repeat: Infinity }}
//       >
//         <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
//           <motion.div
//             className="w-1 h-3 bg-white rounded-full mt-2"
//             animate={{ y: [0, 12, 0] }}
//             transition={{ duration: 2, repeat: Infinity }}
//           />
//         </div>
//       </motion.div>

//       <style jsx>{`
//         .perspective-1000 {
//           perspective: 1000px;
//         }
//         .backface-hidden {
//           backface-visibility: hidden;
//           -webkit-backface-visibility: hidden;
//         }
//         .bg-grid-pattern {
//           background-image: linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
//             linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
//           background-size: 50px 50px;
//         }
//       `}</style>
//     </section>
//   );
// };  


// import { useState } from "react";
// import { motion } from "framer-motion";
// import { Code, Smartphone, Globe, Zap, ArrowRight, MessageCircle} from "lucide-react";

// export const HeroSection = () => {
//   const [isHovered, setIsHovered] = useState(false);
//   const [rotation, setRotation] = useState({ x: 0, y: 0 });

//   // Handle mouse move for 3D effect
//   const handleMouseMove = (e) => {
//     const rect = e.currentTarget.getBoundingClientRect();
//     const x = e.clientX - rect.left;
//     const y = e.clientY - rect.top;

//     const centerX = rect.width / 2;
//     const centerY = rect.height / 2;

//     const rotateX = (y - centerY) / 20;
//     const rotateY = (centerX - x) / 20;

//     setRotation({ x: rotateX, y: rotateY });
//   };

//   const handleMouseLeave = () => {
//     setRotation({ x: 0, y: 0 });
//   };

//   return (
//     <section
//       className="relative min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-emerald-900 px-6 md:px-16 text-white flex items-center justify-center overflow-hidden"
//     >
//       {/* Animated background elements */}
//       <div className="absolute inset-0 overflow-hidden">
//         {[...Array(15)].map((_, i) => (
//           <motion.div
//             key={i}
//             className="absolute rounded-full bg-emerald-500/10"
//             style={{
//               top: `${Math.random() * 100}%`,
//               left: `${Math.random() * 100}%`,
//               width: `${Math.random() * 300 + 50}px`,
//               height: `${Math.random() * 300 + 50}px`,
//             }}
//             animate={{
//               scale: [1, 1.2, 1],
//               rotate: [0, 180, 360],
//             }}
//             transition={{
//               duration: Math.random() * 10 + 10,
//               repeat: Infinity,
//               ease: "linear",
//             }}
//           />
//         ))}
//       </div>

//       <div className="relative z-10 max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-16 w-full py-12">
//         {/* Left Text */}
//         <motion.div
//           initial={{ opacity: 0, x: -60 }}
//           whileInView={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.8 }}
//           viewport={{ once: false }}
//           className="text-center md:text-left md:w-1/2"
//         >
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.2, duration: 0.6 }}
//             viewport={{ once: false }}
//             className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6"
//           >
//             <Zap className="w-4 h-4 text-emerald-400" />
//             <span className="text-sm">Full Stack Developer</span>
//           </motion.div>

//           <h1 className="text-5xl md:text-6xl font-bold leading-tight mb-6">
//             Transforming Ideas Into{" "}
//             <span className="bg-gradient-to-r from-emerald-400 to-blue-500 bg-clip-text text-transparent">
//               Digital Excellence
//             </span>
//           </h1>

//           <motion.p
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.4, duration: 0.6 }}
//             viewport={{ once: false }}
//             className="text-lg md:text-xl text-gray-300 max-w-xl mx-auto md:mx-0 mb-8"
//           >
//             Hi, I'm <strong className="text-white">Momin Hussain</strong> – a passionate Full stack web developer crafting high-performance, responsive websites that drive business growth and deliver exceptional user experiences.
//           </motion.p>

//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.6, duration: 0.6 }}
//             viewport={{ once: false }}
//             className="flex flex-wrap justify-center md:justify-start gap-4 mb-10"
//           >
//             {[
//               { icon: <Code className="w-5 h-5" />, text: "Web Development" },
//               { icon: <Smartphone className="w-5 h-5" />, text: "Mobile Responsive" },
//               { icon: <Globe className="w-5 h-5" />, text: "SEO Optimized" },
//             ].map((item, index) => (
//               <div key={index} className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg">
//                 {item.icon}
//                 <span className="text-sm">{item.text}</span>
//               </div>
//             ))}
//           </motion.div>

//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.8, duration: 0.6 }}
//             viewport={{ once: false }}
//             className="flex flex-wrap justify-center md:justify-start gap-4"
//           >
//             <motion.a
//               href="https://wa.me/923112891862?text=Hi%20Momin%2C%20I%20want%20to%20discuss%20a%20project"
//               target="_blank"
//               rel="noopener noreferrer"
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               onMouseEnter={() => setIsHovered(true)}
//               onMouseLeave={() => setIsHovered(false)}
//               className="flex items-center gap-2 bg-gradient-to-r from-blue-600 to-emerald-600 hover:from-blue-700 hover:to-emerald-700 text-white px-8 py-4 rounded-xl shadow-lg hover:shadow-blue-500/30 transition-all duration-300 font-medium"
//             >
//               <MessageCircle className="w-5 h-5" />
//               Start a Conversation
//               <motion.div
//                 animate={{ x: isHovered ? 5 : 0 }}
//                 transition={{ type: "spring", stiffness: 500 }}
//               >
//                 <ArrowRight className="w-5 h-5" />
//               </motion.div>
//             </motion.a>

//             <motion.a
//               href="#portfolio"
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               className="flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-xl border border-white/20 transition-all duration-300 font-medium"
//             >
//               View My Work
//             </motion.a>
//           </motion.div>
//         </motion.div>

//         {/* Right Side - 3D Element */}
//         <motion.div
//           className="relative w-[270px] sm:w-[400px] md:w-[480px] aspect-square mx-auto"
//           initial={{ opacity: 0, x: 60 }}
//           whileInView={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.8, delay: 0.5 }}
//           viewport={{ once: false }}
//           onMouseMove={handleMouseMove}
//           onMouseLeave={handleMouseLeave}
//           style={{
//             transformStyle: "preserve-3d",
//             perspective: "1200px",
//           }}
//         >
//           {/* Main 3D Cube Container */}
//           <motion.div
//             className="relative w-full h-full"
//             animate={{
//               rotateX: rotation.x,
//               rotateY: rotation.y,
//             }}
//             transition={{ type: "spring", stiffness: 150, damping: 15 }}
//             style={{
//               transformStyle: "preserve-3d",
//             }}
//           >
//             {/* Front Face - Developer Showcase */}
//             <div className="absolute inset-0 backface-hidden">
//               <div className="relative w-full h-full bg-gradient-to-br from-slate-800/40 via-blue-800/40 to-emerald-800/40 backdrop-blur-xl rounded-[40px] border-2 border-white/30 shadow-2xl flex items-center justify-center overflow-hidden">

//                 {/* Animated background patterns */}
//                 <div className="absolute inset-0">
//                   <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(16,185,129,0.2)_0%,transparent_40%)]" />
//                   <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_80%,rgba(59,130,246,0.2)_0%,transparent_40%)]" />
//                   <div className="absolute inset-0" style={{
//                     backgroundImage: `repeating-linear-gradient(45deg, rgba(255,255,255,0.05) 0px, rgba(255,255,255,0.05) 2px, transparent 2px, transparent 10px)`,
//                   }} />
//                 </div>

//                 {/* Floating orbs - matching theme */}
//                 <motion.div
//                   className="absolute w-32 h-32 sm:w-48 sm:h-48 bg-emerald-500/20 rounded-full blur-3xl top-5 left-5"
//                   animate={{
//                     scale: [1, 1.4, 1],
//                     x: [0, 30, 0],
//                     y: [0, -20, 0],
//                   }}
//                   transition={{ duration: 7, repeat: Infinity }}
//                 />
//                 <motion.div
//                   className="absolute w-56 h-56 bg-blue-500/20 rounded-full blur-3xl bottom-5 right-5"
//                   animate={{
//                     scale: [1, 1.5, 1],
//                     x: [0, -30, 0],
//                     y: [0, 30, 0],
//                   }}
//                   transition={{ duration: 8, repeat: Infinity }}
//                 />
//                 <motion.div
//                   className="absolute w-40 h-40 bg-emerald-400/20 rounded-full blur-3xl top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
//                   animate={{
//                     scale: [1, 1.3, 1],
//                     opacity: [0.2, 0.5, 0.2],
//                   }}
//                   transition={{ duration: 6, repeat: Infinity }}
//                 />

//                 {/* Main Content */}
//                 <div className="relative z-20 w-full h-full flex flex-col items-center justify-center p-8">

//                   {/* 3D Rotating Icon Sphere */}
//                   <motion.div
//                     animate={{
//                       rotateY: [0, 360],
//                       rotateX: [0, 15, 0, -15, 0],
//                     }}
//                     transition={{
//                       rotateY: { duration: 20, repeat: Infinity, ease: "linear" },
//                       rotateX: { duration: 8, repeat: Infinity, ease: "easeInOut" },
//                     }}
//                     className="relative mb-6"
//                   >
//                     {/* Glowing rings */}
//                     <div className="absolute inset-0 rounded-full bg-gradient-to-r from-emerald-500 via-blue-500 to-emerald-400 blur-3xl opacity-40" />

//                     {/* Main icon container */}
//                     <div className="relative w-56 h-56">
//                       {/* Outer rotating ring */}
//                       <motion.div
//                         className="absolute inset-0 rounded-full border-4 border-transparent"
//                         style={{
//                           background: "linear-gradient(135deg, #10B981, #3B82F6, #10B981)",
//                           WebkitMask: "linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0)",
//                           WebkitMaskComposite: "destination-out",
//                           maskComposite: "exclude",
//                         }}
//                         animate={{ rotate: 360 }}
//                         transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
//                       />

//                       {/* Middle ring */}
//                       <motion.div
//                         className="absolute inset-3 rounded-full border-2 border-dashed border-white/40"
//                         animate={{ rotate: -360 }}
//                         transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
//                       />

//                       {/* Inner ring */}
//                       <div className="absolute inset-6 rounded-full bg-gradient-to-br from-emerald-600/20 via-blue-600/20 to-emerald-600/20 backdrop-blur-sm border border-white/30 shadow-xl flex items-center justify-center overflow-hidden">

//                         {/* Floating particles */}
//                         {[...Array(8)].map((_, i) => (
//                           <motion.div
//                             key={i}
//                             className="absolute w-2 h-2 rounded-full"
//                             style={{
//                               background: i % 2 === 0 ? '#10B981' : '#3B82F6',
//                               top: `${Math.random() * 100}%`,
//                               left: `${Math.random() * 100}%`,
//                             }}
//                             animate={{
//                               y: [0, -40, 0],
//                               x: [0, i % 2 === 0 ? 20 : -20, 0],
//                               opacity: [0, 1, 0],
//                               scale: [0, 1.5, 0],
//                             }}
//                             transition={{
//                               duration: 3 + i,
//                               repeat: Infinity,
//                               delay: i * 0.3,
//                             }}
//                           />
//                         ))}

//                         {/* Central Developer Icon */}
//                         <svg viewBox="0 0 120 120" className="w-32 h-32 z-10">
//                           <defs>
//                             <linearGradient id="devGrad" x1="0%" y1="0%" x2="100%" y2="100%">
//                               <stop offset="0%" stopColor="#10B981">
//                                 <animate attributeName="stop-color" values="#10B981; #3B82F6; #10B981" dur="5s" repeatCount="indefinite" />
//                               </stop>
//                               <stop offset="50%" stopColor="#3B82F6">
//                                 <animate attributeName="stop-color" values="#3B82F6; #10B981; #3B82F6" dur="5s" repeatCount="indefinite" />
//                               </stop>
//                               <stop offset="100%" stopColor="#10B981">
//                                 <animate attributeName="stop-color" values="#10B981; #3B82F6; #10B981" dur="5s" repeatCount="indefinite" />
//                               </stop>
//                             </linearGradient>
//                             <filter id="glow">
//                               <feGaussianBlur stdDeviation="3" result="coloredBlur" />
//                               <feMerge>
//                                 <feMergeNode in="coloredBlur" />
//                                 <feMergeNode in="SourceGraphic" />
//                               </feMerge>
//                             </filter>
//                           </defs>

//                           <g filter="url(#glow)">
//                             {/* Head */}
//                             <circle cx="60" cy="35" r="12" fill="url(#devGrad)" fillOpacity="0.9" />

//                             {/* Body */}
//                             <rect x="48" y="45" width="24" height="30" fill="url(#devGrad)" fillOpacity="0.7" rx="4" />

//                             {/* Laptop base */}
//                             <rect x="30" y="75" width="60" height="8" fill="url(#devGrad)" fillOpacity="0.9" rx="2" />

//                             {/* Laptop screen */}
//                             <rect x="35" y="50" width="50" height="30" fill="none" stroke="url(#devGrad)" strokeWidth="3" rx="3" />

//                             {/* Code lines */}
//                             <line x1="45" y1="62" x2="75" y2="62" stroke="white" strokeWidth="2" strokeLinecap="round">
//                               <animate attributeName="x2" values="75;70;75" dur="2s" repeatCount="indefinite" />
//                             </line>
//                             <line x1="45" y1="68" x2="65" y2="68" stroke="white" strokeWidth="2" strokeLinecap="round">
//                               <animate attributeName="x2" values="65;60;65" dur="2s" repeatCount="indefinite" begin="0.5s" />
//                             </line>
//                             <line x1="45" y1="74" x2="55" y2="74" stroke="white" strokeWidth="2" strokeLinecap="round">
//                               <animate attributeName="x2" values="55;50;55" dur="2s" repeatCount="indefinite" begin="1s" />
//                             </line>

//                             {/* Code symbols */}
//                             <text x="15" y="25" fill="white" fontSize="12" opacity="0.7">&lt;/&gt;</text>
//                             <text x="90" y="90" fill="white" fontSize="12" opacity="0.7">{'{ }'}</text>
//                           </g>
//                         </svg>
//                       </div>
//                     </div>
//                   </motion.div>

//                   {/* Title */}
//                   <motion.h3
//                     initial={{ opacity: 0, y: 20 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ delay: 0.3 }}
//                     className="text-3xl font-black mb-1 text-center"
//                   >
//                     <span className="bg-gradient-to-r from-emerald-400 via-blue-400 to-emerald-400 bg-clip-text text-transparent bg-[length:200%_auto] animate-gradient">
//                       Momin Hussain
//                     </span>
//                   </motion.h3>

//                   <motion.p
//                     initial={{ opacity: 0, y: 20 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ delay: 0.4 }}
//                     className="text-lg sm:text-xl font-medium text-white/90 mb-4"
//                   >
//                     Full Stack Developer
//                   </motion.p>

//                   {/* Tech stack badges */}
//                   <motion.div
//                     className="flex flex-wrap justify-center gap-2"
//                     initial={{ opacity: 0, y: 20 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ delay: 0.5 }}
//                   >
//                     {[
//                       { name: 'React', color: 'from-emerald-400 to-emerald-500' },
//                       { name: 'Node.js', color: 'from-emerald-500 to-green-500' },
//                       { name: 'MySql', color: 'from-blue-400 to-blue-500' },
//                       { name: 'TypeScript', color: 'from-emerald-500 to-blue-500' },
//                       { name: 'Next.js', color: 'from-gray-700 to-gray-900' },
//                       { name: 'MongoDB', color: 'from-emerald-500 to-teal-500' }
//                     ].map((tech, i) => (
//                       <motion.span
//                         key={tech.name}
//                         className={`px-3 py-1.5 bg-gradient-to-r ${tech.color} text-white text-xs font-semibold rounded-full shadow-lg`}
//                         initial={{ scale: 0 }}
//                         animate={{ scale: 1 }}
//                         transition={{ delay: 0.6 + i * 0.1, type: "spring" }}
//                         whileHover={{ scale: 1.1, y: -2 }}
//                       >
//                         {tech.name}
//                       </motion.span>
//                     ))}
//                   </motion.div>

//                   {/* Experience indicator */}
//                   <motion.div
//                     className="flex items-center gap-4 mt-5"
//                     initial={{ opacity: 0 }}
//                     animate={{ opacity: 1 }}
//                     transition={{ delay: 0.8 }}
//                   >
//                     <div className="flex items-center gap-1">
//                       {[1, 2, 3, 4, 5].map((star) => (
//                         <motion.svg
//                           key={star}
//                           className="w-4 h-4 text-emerald-400"
//                           fill="currentColor"
//                           viewBox="0 0 20 20"
//                           initial={{ scale: 0 }}
//                           animate={{ scale: 1 }}
//                           transition={{ delay: 0.9 + star * 0.1 }}
//                         >
//                           <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//                         </motion.svg>
//                       ))}
//                     </div>
//                     <span className="text-white/80 text-sm">2+ Years Experience</span>
//                   </motion.div>
//                 </div>
//               </div>
//             </div>

//             {/* Back Face - Skills */}
//             <div className="absolute inset-0 backface-hidden" style={{ transform: "rotateY(180deg)" }}>
//               <div className="relative w-full h-full bg-gradient-to-br from-slate-800/40 via-blue-800/40 to-emerald-800/40 backdrop-blur-xl rounded-[40px] border-2 border-white/30 shadow-2xl flex items-center justify-center overflow-hidden p-6">
//                 <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(16,185,129,0.1)_0%,transparent_70%)]" />

//                 <div className="relative z-10 text-center">
//                   <motion.h3
//                     className="text-3xl font-bold mb-4 bg-gradient-to-r from-emerald-400 to-blue-400 bg-clip-text text-transparent"
//                     animate={{ scale: [1, 1.05, 1] }}
//                     transition={{ duration: 3, repeat: Infinity }}
//                   >
//                     Skills & Expertise
//                   </motion.h3>

//                   <div className="grid grid-cols-2 gap-3">
//                     {[
//                       { name: 'Frontend', level: 95 },
//                       { name: 'Backend', level: 90 },
//                       { name: 'Database', level: 85 },
//                       { name: 'DevOps', level: 80 },
//                       { name: 'UI/UX', level: 88 },
//                       { name: 'Mobile', level: 82 }
//                     ].map((skill, i) => (
//                       <motion.div
//                         key={skill.name}
//                         className="bg-white/10 backdrop-blur-sm rounded-xl p-3 border border-white/20"
//                         initial={{ opacity: 0, y: 20 }}
//                         animate={{ opacity: 1, y: 0 }}
//                         transition={{ delay: i * 0.1 }}
//                       >
//                         <div className="text-white font-medium mb-1">{skill.name}</div>
//                         <div className="w-full bg-white/20 rounded-full h-2">
//                           <motion.div
//                             className="h-full rounded-full bg-gradient-to-r from-emerald-400 to-blue-400"
//                             initial={{ width: 0 }}
//                             animate={{ width: `${skill.level}%` }}
//                             transition={{ delay: 0.5 + i * 0.1, duration: 1 }}
//                           />
//                         </div>
//                       </motion.div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Right Face - Projects */}
//             <div className="absolute inset-0 backface-hidden" style={{ transform: "rotateY(90deg) translateZ(240px)" }}>
//               <div className="relative w-full h-full bg-gradient-to-br from-slate-800/40 via-blue-800/40 to-emerald-800/40 backdrop-blur-xl rounded-[40px] border-2 border-white/30 shadow-2xl flex items-center justify-center overflow-hidden p-6">
//                 <div className="absolute inset-0 bg-[conic-gradient(from_0deg,rgba(16,185,129,0.05)_0deg,transparent_120deg)]" />

//                 <div className="relative z-10 text-center">
//                   <motion.h3
//                     className="text-3xl font-bold mb-4 bg-gradient-to-r from-emerald-400 to-blue-400 bg-clip-text text-transparent"
//                     animate={{ scale: [1, 1.05, 1] }}
//                     transition={{ duration: 3, repeat: Infinity }}
//                   >
//                     Recent Projects
//                   </motion.h3>

//                   <div className="space-y-3">
//                     {[
//                       { name: 'E-Commerce Platform', tech: 'React, Node.js, MongoDB' },
//                       { name: 'AI Analytics Dashboard', tech: 'Python, TensorFlow, Next.js' },
//                       { name: 'Mobile Banking App', tech: 'React Native, Node.js' }
//                     ].map((project, i) => (
//                       <motion.div
//                         key={project.name}
//                         className="bg-white/10 backdrop-blur-sm rounded-xl p-3 border border-white/20 text-left"
//                         initial={{ opacity: 0, x: 20 }}
//                         animate={{ opacity: 1, x: 0 }}
//                         transition={{ delay: i * 0.1 }}
//                         whileHover={{ scale: 1.02, backgroundColor: 'rgba(255,255,255,0.2)' }}
//                       >
//                         <div className="text-white font-semibold">{project.name}</div>
//                         <div className="text-white/60 text-sm">{project.tech}</div>
//                       </motion.div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Left Face - Contact */}
//             <div className="absolute inset-0 backface-hidden" style={{ transform: "rotateY(-90deg) translateZ(240px)" }}>
//               <div className="relative w-full h-full bg-gradient-to-br from-slate-800/40 via-blue-800/40 to-emerald-800/40 backdrop-blur-xl rounded-[40px] border-2 border-white/30 shadow-2xl flex items-center justify-center overflow-hidden p-6">
//                 <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(16,185,129,0.1)_0%,transparent_80%)]" />

//                 <div className="relative z-10 text-center">
//                   <motion.h3
//                     className="text-3xl font-bold mb-4 bg-gradient-to-r from-emerald-400 to-blue-400 bg-clip-text text-transparent"
//                     animate={{ scale: [1, 1.05, 1] }}
//                     transition={{ duration: 3, repeat: Infinity }}
//                   >
//                     Let's Connect
//                   </motion.h3>

//                   <div className="space-y-3">
//                     {[
//                       { icon: '📧', text: 'momin@devstack.com' },
//                       { icon: '📱', text: '+92 311 2891862' },
//                       { icon: '💬', text: 'Available for work' }
//                     ].map((item, i) => (
//                       <motion.div
//                         key={item.text}
//                         className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-xl p-3 border border-white/20"
//                         initial={{ opacity: 0, x: -20 }}
//                         animate={{ opacity: 1, x: 0 }}
//                         transition={{ delay: i * 0.1 }}
//                         whileHover={{ scale: 1.02 }}
//                       >
//                         <span className="text-2xl">{item.icon}</span>
//                         <span className="text-white">{item.text}</span>
//                       </motion.div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </motion.div>

//           {/* Floating decorative elements */}
//           <motion.div
//             className="absolute -top-8 -right-8 w-16 h-16 bg-gradient-to-r from-emerald-500 to-blue-500 rounded-2xl shadow-2xl flex items-center justify-center border-2 border-white/30"
//             animate={{
//               y: [0, -15, 0],
//               rotate: [0, 15, 0],
//               scale: [1, 1.1, 1],
//             }}
//             transition={{ duration: 4, repeat: Infinity }}
//           >
//             <span className="text-white text-2xl">⚡</span>
//           </motion.div>

//           <motion.div
//             className="absolute -bottom-8 -left-8 w-16 h-16 bg-gradient-to-r from-blue-500 to-emerald-400 rounded-2xl shadow-2xl flex items-center justify-center border-2 border-white/30"
//             animate={{
//               y: [0, 15, 0],
//               rotate: [0, -15, 0],
//               scale: [1, 1.1, 1],
//             }}
//             transition={{ duration: 4, repeat: Infinity, delay: 1 }}
//           >
//             <span className="text-white text-2xl">💻</span>
//           </motion.div>

//           {/* Orbiting icons */}
//           {['🚀', '💡', '✨', '🌟'].map((icon, i) => (
//             <motion.div
//               key={i}
//               className="absolute w-10 h-10 bg-gradient-to-r from-emerald-500/50 to-blue-500/50 backdrop-blur-sm rounded-xl flex items-center justify-center border border-white/30 text-xl"
//               animate={{
//                 rotate: [0, 360],
//                 x: [0, Math.cos(i * 90) * 180, 0],
//                 y: [0, Math.sin(i * 90) * 180, 0],
//               }}
//               transition={{
//                 duration: 15,
//                 repeat: Infinity,
//                 delay: i * 2,
//                 ease: "linear",
//               }}
//             >
//               {icon}
//             </motion.div>
//           ))}

//           {/* Floating particles */}
//           {[...Array(10)].map((_, i) => (
//             <motion.div
//               key={i}
//               className="absolute w-1 h-1 rounded-full"
//               style={{
//                 background: i % 2 === 0 ? '#10B981' : '#3B82F6',
//                 top: `${Math.random() * 100}%`,
//                 left: `${Math.random() * 100}%`,
//               }}
//               animate={{
//                 y: [0, -30, 0],
//                 x: [0, i % 2 === 0 ? 20 : -20, 0],
//                 scale: [0, 1, 0],
//                 opacity: [0, 1, 0],
//               }}
//               transition={{
//                 duration: 3 + i,
//                 repeat: Infinity,
//                 delay: i * 0.2,
//               }}
//             />
//           ))}
//         </motion.div>
//       </div>

//       {/* Scroll indicator */}
//       <motion.div
//         className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
//         animate={{ y: [0, 10, 0] }}
//         transition={{ duration: 2, repeat: Infinity }}
//       >
//         <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
//           <motion.div
//             className="w-1 h-3 bg-white rounded-full mt-2"
//             animate={{ y: [0, 12, 0] }}
//             transition={{ duration: 2, repeat: Infinity }}
//           />
//         </div>
//       </motion.div>

//       <style jsx>{`
//         .perspective-1000 {
//           perspective: 1000px;
//         }
//         .backface-hidden {
//           backface-visibility: hidden;
//           -webkit-backface-visibility: hidden;
//         }
//         .bg-grid-pattern {
//           background-image: linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
//             linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
//           background-size: 50px 50px;
//         }
//         .animate-gradient {
//           background-size: 200% auto;
//           animation: gradient 3s linear infinite;
//         }
//         @keyframes gradient {
//           0% {
//             background-position: 0% 50%;
//           }
//           50% {
//             background-position: 100% 50%;
//           }
//           100% {
//             background-position: 0% 50%;
//           }
//         }
//       `}</style>
//     </section>
//   );
// };


import { useState } from "react";
import { motion } from "framer-motion";
import { Code, Smartphone, Globe, Zap, ArrowRight, MessageCircle } from "lucide-react";
import {
  Rocket,
  Lightbulb,
  Sparkles,
  Stars,
} from "lucide-react";

// import {
//   SiReact,
//   SiJavascript,
//   SiTypescript,
//   SiNextdotjs,
// } from "react-icons/si";

export const HeroSection = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [rotation, setRotation] = useState({ x: 0, y: 0 });

  // Handle mouse move for 3D effect
  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const rotateX = (y - centerY) / 20;
    const rotateY = (centerX - x) / 20;

    setRotation({ x: rotateX, y: rotateY });
  };

  const handleMouseLeave = () => {
    setRotation({ x: 0, y: 0 });
  };

  return (
    <section
      className="relative min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-emerald-900 px-4 sm:px-6 md:px-16 text-white flex items-center justify-center overflow-hidden"
    >
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        {[...Array(15)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute rounded-full bg-emerald-500/10"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              width: `${Math.random() * 300 + 50}px`,
              height: `${Math.random() * 300 + 50}px`,
            }}
            animate={{
              scale: [1, 1.2, 1],
              rotate: [0, 180, 360],
            }}
            transition={{
              duration: Math.random() * 10 + 10,
              repeat: Infinity,
              ease: "linear",
            }}
          />
        ))}
      </div>

      <div className="relative z-10 max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-16 w-full py-8 md:py-12">
        {/* Left Text */}
        <motion.div
          initial={{ opacity: 0, x: -60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: false }}
          className="text-center lg:text-left lg:w-1/2 w-full"
        >
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            viewport={{ once: false }}
            className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-3 sm:px-4 py-2 rounded-full mb-4 sm:mb-6"
          >
            <Zap className="w-3 h-3 sm:w-4 sm:h-4 text-emerald-400" />
            <span className="text-xs sm:text-sm">Full Stack Developer</span>
          </motion.div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 sm:mb-6">
            Transforming Ideas Into{" "}
            <span className="bg-gradient-to-r from-emerald-400 to-blue-500 bg-clip-text text-transparent">
              Digital Excellence
            </span>
          </h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
            viewport={{ once: false }}
            className="text-base sm:text-lg md:text-xl text-gray-300 max-w-xl mx-auto lg:mx-0 mb-6 sm:mb-8 font-serif"
          >
            Hi, I'm <strong className="text-white">Momin Hussain</strong> a passionate Full stack web developer crafting high performance, responsive websites that drive business growth and deliver exceptional user experiences.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.6 }}
            viewport={{ once: false }}
            className="flex flex-wrap justify-center lg:justify-start gap-2 sm:gap-3 md:gap-4 mb-6 sm:mb-8 md:mb-10"
          >
            {[
              { icon: <Code className="w-4 h-4 sm:w-5 sm:h-5" />, text: "Web Development" },
              { icon: <Smartphone className="w-4 h-4 sm:w-5 sm:h-5" />, text: "Mobile Responsive" },
              { icon: <Globe className="w-4 h-4 sm:w-5 sm:h-5" />, text: "SEO Optimized" },
            ].map((item, index) => (
              <div key={index} className="flex items-center gap-1 sm:gap-2 bg-white/10 backdrop-blur-sm px-2 sm:px-3 md:px-4 py-1.5 sm:py-2 rounded-lg">
                {item.icon}
                <span className="text-xs sm:text-sm">{item.text}</span>
              </div>
            ))}
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 0.6 }}
            viewport={{ once: false }}
            className="flex flex-wrap justify-center lg:justify-start gap-3 sm:gap-4"
          >
            <motion.a
              href="https://wa.me/923112891862?text=Hi%20Momin%2C%20I%20want%20to%20discuss%20a%20project"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              className="flex items-center gap-2 bg-gradient-to-r from-blue-600 to-emerald-600 hover:from-blue-700 hover:to-emerald-700 text-white px-4 sm:px-6 md:px-8 py-2.5 sm:py-3 md:py-4 rounded-xl shadow-lg hover:shadow-blue-500/30 transition-all duration-300 font-medium text-sm sm:text-base"
            >
              <MessageCircle className="w-4 h-4 sm:w-5 sm:h-5" />
              Start a Conversation
              <motion.div
                animate={{ x: isHovered ? 5 : 0 }}
                transition={{ type: "spring", stiffness: 500 }}
              >
                <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" />
              </motion.div>
            </motion.a>

            <motion.a
              href="#portfolio"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white px-4 sm:px-6 md:px-8 py-2.5 sm:py-3 md:py-4 rounded-xl border border-white/20 transition-all duration-300 font-medium text-sm sm:text-base"
            >
              View My Work
            </motion.a>
          </motion.div>
        </motion.div>

        {/* Right Side - 3D Element - Responsive Sizing */}
        <motion.div
          className="relative w-[300px] sm:w-[320px] md:w-[380px] lg:w-[480px] aspect-square mx-auto mt-8 lg:mt-0"
          initial={{ opacity: 0, x: 60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          viewport={{ once: false }}
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
          style={{
            transformStyle: "preserve-3d",
            perspective: "1200px",
          }}
        >
          {/* Main 3D Cube Container */}
          <motion.div
            className="relative w-full h-full"
            animate={{
              rotateX: rotation.x,
              rotateY: rotation.y,
            }}
            transition={{ type: "spring", stiffness: 150, damping: 15 }}
            style={{
              transformStyle: "preserve-3d",
            }}
          >
            {/* Front Face - Developer Showcase */}
            <div className="absolute inset-0 backface-hidden">
              <div className="relative w-full h-full bg-gradient-to-br from-slate-800/40 via-blue-800/40 to-emerald-800/40 backdrop-blur-xl rounded-[30px] sm:rounded-[35px] md:rounded-[40px] border-2 border-white/30 shadow-2xl flex items-center justify-center overflow-hidden">

                {/* Animated background patterns */}
                <div className="absolute inset-0">
                  <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(16,185,129,0.2)_0%,transparent_40%)]" />
                  <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_80%,rgba(59,130,246,0.2)_0%,transparent_40%)]" />
                  <div className="absolute inset-0" style={{
                    backgroundImage: `repeating-linear-gradient(45deg, rgba(255,255,255,0.05) 0px, rgba(255,255,255,0.05) 2px, transparent 2px, transparent 10px)`,
                  }} />
                </div>

                {/* Floating orbs - scaled down for mobile */}
                <motion.div
                  className="absolute w-32 sm:w-40 md:w-48 h-32 sm:h-40 md:h-48 bg-emerald-500/20 rounded-full blur-3xl top-5 left-5"
                  animate={{
                    scale: [1, 1.4, 1],
                    x: [0, 30, 0],
                    y: [0, -20, 0],
                  }}
                  transition={{ duration: 7, repeat: Infinity }}
                />
                <motion.div
                  className="absolute w-36 sm:w-44 md:w-56 h-36 sm:h-44 md:h-56 bg-blue-500/20 rounded-full blur-3xl bottom-5 right-5"
                  animate={{
                    scale: [1, 1.5, 1],
                    x: [0, -30, 0],
                    y: [0, 30, 0],
                  }}
                  transition={{ duration: 8, repeat: Infinity }}
                />
                <motion.div
                  className="absolute w-28 sm:w-32 md:w-40 h-28 sm:h-32 md:h-40 bg-emerald-400/20 rounded-full blur-3xl top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                  animate={{
                    scale: [1, 1.3, 1],
                    opacity: [0.2, 0.5, 0.2],
                  }}
                  transition={{ duration: 6, repeat: Infinity }}
                />

                {/* Main Content */}
                <div className="relative z-20 w-full h-full flex flex-col items-center justify-center p-4 sm:p-6 md:p-8">

                  {/* 3D Rotating Icon Sphere - scaled down for mobile */}
                  <motion.div
                    animate={{
                      rotateY: [0, 360],
                      rotateX: [0, 15, 0, -15, 0],
                    }}
                    transition={{
                      rotateY: { duration: 20, repeat: Infinity, ease: "linear" },
                      rotateX: { duration: 8, repeat: Infinity, ease: "easeInOut" },
                    }}
                    className="relative mb-3 sm:mb-4 md:mb-6"
                  >
                    {/* Glowing rings */}
                    <div className="absolute inset-0 rounded-full bg-gradient-to-r from-emerald-500 via-blue-500 to-emerald-400 blur-3xl opacity-40" />

                    {/* Main icon container */}
                    <div className="relative w-36 sm:w-44 md:w-52 lg:w-56 h-36 sm:h-44 md:h-52 lg:h-56">
                      {/* Outer rotating ring */}
                      <motion.div
                        className="absolute inset-0 rounded-full border-4 border-transparent"
                        style={{
                          background: "linear-gradient(135deg, #10B981, #3B82F6, #10B981)",
                          WebkitMask: "linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0)",
                          WebkitMaskComposite: "destination-out",
                          maskComposite: "exclude",
                        }}
                        animate={{ rotate: 360 }}
                        transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
                      />

                      {/* Middle ring */}
                      <motion.div
                        className="absolute inset-2 sm:inset-3 rounded-full border-2 border-dashed border-white/40"
                        animate={{ rotate: -360 }}
                        transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
                      />

                      {/* Inner ring */}
                      <div className="absolute inset-4 sm:inset-5 md:inset-6 rounded-full bg-gradient-to-br from-emerald-600/20 via-blue-600/20 to-emerald-600/20 backdrop-blur-sm border border-white/30 shadow-xl flex items-center justify-center overflow-hidden">

                        {/* Floating particles - fewer on mobile */}
                        {[...Array(6)].map((_, i) => (
                          <motion.div
                            key={i}
                            className="absolute w-1.5 sm:w-2 h-1.5 sm:h-2 rounded-full"
                            style={{
                              background: i % 2 === 0 ? '#10B981' : '#3B82F6',
                              top: `${Math.random() * 100}%`,
                              left: `${Math.random() * 100}%`,
                            }}
                            animate={{
                              y: [0, -30, 0],
                              x: [0, i % 2 === 0 ? 15 : -15, 0],
                              opacity: [0, 1, 0],
                              scale: [0, 1.5, 0],
                            }}
                            transition={{
                              duration: 3 + i,
                              repeat: Infinity,
                              delay: i * 0.3,
                            }}
                          />
                        ))}

                        {/* Central Developer Icon - scaled down for mobile */}
                        <svg viewBox="0 0 120 120" className="w-20 sm:w-24 md:w-28 lg:w-32 h-20 sm:h-24 md:h-28 lg:h-32 z-10">
                          <defs>
                            <linearGradient id="devGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                              <stop offset="0%" stopColor="#10B981">
                                <animate attributeName="stop-color" values="#10B981; #3B82F6; #10B981" dur="5s" repeatCount="indefinite" />
                              </stop>
                              <stop offset="50%" stopColor="#3B82F6">
                                <animate attributeName="stop-color" values="#3B82F6; #10B981; #3B82F6" dur="5s" repeatCount="indefinite" />
                              </stop>
                              <stop offset="100%" stopColor="#10B981">
                                <animate attributeName="stop-color" values="#10B981; #3B82F6; #10B981" dur="5s" repeatCount="indefinite" />
                              </stop>
                            </linearGradient>
                            <filter id="glow">
                              <feGaussianBlur stdDeviation="2" result="coloredBlur" />
                              <feMerge>
                                <feMergeNode in="coloredBlur" />
                                <feMergeNode in="SourceGraphic" />
                              </feMerge>
                            </filter>
                          </defs>

                          <g filter="url(#glow)">
                            {/* Head */}
                            <circle cx="60" cy="35" r="12" fill="url(#devGrad)" fillOpacity="0.9" />

                            {/* Body */}
                            <rect x="48" y="45" width="24" height="30" fill="url(#devGrad)" fillOpacity="0.7" rx="4" />

                            {/* Laptop base */}
                            <rect x="30" y="75" width="60" height="8" fill="url(#devGrad)" fillOpacity="0.9" rx="2" />

                            {/* Laptop screen */}
                            <rect x="35" y="50" width="50" height="30" fill="none" stroke="url(#devGrad)" strokeWidth="3" rx="3" />

                            {/* Code lines */}
                            <line x1="45" y1="62" x2="75" y2="62" stroke="white" strokeWidth="2" strokeLinecap="round">
                              <animate attributeName="x2" values="75;70;75" dur="2s" repeatCount="indefinite" />
                            </line>
                            <line x1="45" y1="68" x2="65" y2="68" stroke="white" strokeWidth="2" strokeLinecap="round">
                              <animate attributeName="x2" values="65;60;65" dur="2s" repeatCount="indefinite" begin="0.5s" />
                            </line>
                            <line x1="45" y1="74" x2="55" y2="74" stroke="white" strokeWidth="2" strokeLinecap="round">
                              <animate attributeName="x2" values="55;50;55" dur="2s" repeatCount="indefinite" begin="1s" />
                            </line>

                            {/* Code symbols - smaller on mobile */}
                            <text x="15" y="25" fill="white" fontSize="10" opacity="0.7">&lt;/&gt;</text>
                            <text x="90" y="90" fill="white" fontSize="10" opacity="0.7">{'{ }'}</text>
                          </g>
                        </svg>
                      </div>
                    </div>
                  </motion.div>

                  {/* Title - responsive font sizes */}
                  <motion.h3
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3 }}
                    className="text-xl sm:text-2xl md:text-3xl font-black mb-0.5 sm:mb-1 text-center"
                  >
                    <span className="bg-gradient-to-r from-emerald-400 via-blue-400 to-emerald-400 bg-clip-text text-transparent bg-[length:200%_auto] animate-gradient">
                      Momin Hussain
                    </span>
                  </motion.h3>

                  <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4 }}
                    className="text-base sm:text-lg md:text-xl font-medium text-white/90 mb-2 sm:mb-3 md:mb-4"
                  >
                    Full Stack Developer
                  </motion.p>

                  {/* Tech stack badges - responsive sizing */}
                  <motion.div
                    className="flex flex-wrap justify-center gap-1.5 sm:gap-2 px-2"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5 }}
                  >
                    {[
                      { name: 'React', color: 'from-emerald-400 to-emerald-500' },
                      { name: 'Node.js', color: 'from-emerald-500 to-green-500' },
                      { name: 'MySql', color: 'from-blue-400 to-blue-500' },
                      { name: 'TypeScript', color: 'from-emerald-500 to-blue-500' },
                      { name: 'Next.js', color: 'from-gray-700 to-gray-900' },
                      { name: 'MongoDB', color: 'from-emerald-500 to-teal-500' }
                    ].map((tech, i) => (
                      <motion.span
                        key={tech.name}
                        className={`px-2 sm:px-3 py-1 sm:py-1.5 bg-gradient-to-r ${tech.color} text-white text-[10px] sm:text-xs font-semibold rounded-full shadow-lg`}
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        transition={{ delay: 0.6 + i * 0.1, type: "spring" }}
                        whileHover={{ scale: 1.05, y: -1 }}
                      >
                        {tech.name}
                      </motion.span>
                    ))}
                  </motion.div>

                  {/* Experience indicator - responsive */}
                  <motion.div
                    className="flex items-center gap-2 sm:gap-3 md:gap-4 mt-3 sm:mt-4 md:mt-5"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.8 }}
                  >
                    <div className="flex items-center gap-0.5 sm:gap-1">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <motion.svg
                          key={star}
                          className="w-3 h-3 sm:w-4 sm:h-4 text-emerald-400"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          initial={{ scale: 0 }}
                          animate={{ scale: 1 }}
                          transition={{ delay: 0.9 + star * 0.1 }}
                        >
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                        </motion.svg>
                      ))}
                    </div>
                    <span className="text-white/70 sm:text-white/80 text-[10px] sm:text-xs md:text-sm">3+ Years Experience</span>
                  </motion.div>
                </div>
              </div>
            </div>

            {/* Back Face - Skills - responsive text sizes */}
            {/* <div className="absolute inset-0 backface-hidden" style={{ transform: "rotateY(180deg)" }}>
              <div className="relative w-full h-full bg-gradient-to-br from-slate-800/40 via-blue-800/40 to-emerald-800/40 backdrop-blur-xl rounded-[30px] sm:rounded-[35px] md:rounded-[40px] border-2 border-white/30 shadow-2xl flex items-center justify-center overflow-hidden p-4 sm:p-5 md:p-6">
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(16,185,129,0.1)_0%,transparent_70%)]" />

                <div className="relative z-10 text-center w-full">
                  <motion.h3
                    className="text-xl sm:text-2xl md:text-3xl font-bold mb-2 sm:mb-3 md:mb-4 bg-gradient-to-r from-emerald-400 to-blue-400 bg-clip-text text-transparent"
                    animate={{ scale: [1, 1.05, 1] }}
                    transition={{ duration: 3, repeat: Infinity }}
                  >
                    Skills & Expertise
                  </motion.h3>

                  <div className="grid grid-cols-2 gap-1.5 sm:gap-2 md:gap-3">
                    {[
                      { name: 'Frontend', level: 95 },
                      { name: 'Backend', level: 90 },
                      { name: 'Database', level: 85 },
                      { name: 'DevOps', level: 80 },
                      { name: 'UI/UX', level: 88 },
                      { name: 'Mobile', level: 82 }
                    ].map((skill, i) => (
                      <motion.div
                        key={skill.name}
                        className="bg-white/10 backdrop-blur-sm rounded-lg sm:rounded-xl p-2 sm:p-3 border border-white/20"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: i * 0.1 }}
                      >
                        <div className="text-white font-medium text-xs sm:text-sm mb-1">{skill.name}</div>
                        <div className="w-full bg-white/20 rounded-full h-1.5 sm:h-2">
                          <motion.div
                            className="h-full rounded-full bg-gradient-to-r from-emerald-400 to-blue-400"
                            initial={{ width: 0 }}
                            animate={{ width: `${skill.level}%` }}
                            transition={{ delay: 0.5 + i * 0.1, duration: 1 }}
                          />
                        </div>
                      </motion.div>
                    ))}
                  </div>
                </div>
              </div>
            </div> */}

            {/* Right Face - Projects - responsive */}
            {/* <div className="absolute inset-0 backface-hidden" style={{ transform: "rotateY(90deg) translateZ(140px) sm:translateZ(160px) md:translateZ(190px) lg:translateZ(240px)" }}>
              <div className="relative w-full h-full bg-gradient-to-br from-slate-800/40 via-blue-800/40 to-emerald-800/40 backdrop-blur-xl rounded-[30px] sm:rounded-[35px] md:rounded-[40px] border-2 border-white/30 shadow-2xl flex items-center justify-center overflow-hidden p-4 sm:p-5 md:p-6">
                <div className="absolute inset-0 bg-[conic-gradient(from_0deg,rgba(16,185,129,0.05)_0deg,transparent_120deg)]" />

                <div className="relative z-10 text-center w-full">
                  <motion.h3
                    className="text-xl sm:text-2xl md:text-3xl font-bold mb-2 sm:mb-3 md:mb-4 bg-gradient-to-r from-emerald-400 to-blue-400 bg-clip-text text-transparent"
                    animate={{ scale: [1, 1.05, 1] }}
                    transition={{ duration: 3, repeat: Infinity }}
                  >
                    Recent Projects
                  </motion.h3>

                  <div className="space-y-2 sm:space-y-3">
                    {[
                      { name: 'E-Commerce Platform', tech: 'React, Node.js, MongoDB' },
                      { name: 'AI Analytics Dashboard', tech: 'Python, TensorFlow, Next.js' },
                      { name: 'Mobile Banking App', tech: 'React Native, Node.js' }
                    ].map((project, i) => (
                      <motion.div
                        key={project.name}
                        className="bg-white/10 backdrop-blur-sm rounded-lg sm:rounded-xl p-2 sm:p-3 border border-white/20 text-left"
                        initial={{ opacity: 0, x: 20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: i * 0.1 }}
                        whileHover={{ scale: 1.02, backgroundColor: 'rgba(255,255,255,0.2)' }}
                      >
                        <div className="text-white font-semibold text-xs sm:text-sm md:text-base">{project.name}</div>
                        <div className="text-white/60 text-[10px] sm:text-xs">{project.tech}</div>
                      </motion.div>
                    ))}
                  </div>
                </div>
              </div>
            </div> */}

            {/* Left Face - Contact - responsive */}
            {/* <div className="absolute inset-0 backface-hidden" style={{ transform: "rotateY(-90deg) translateZ(140px) sm:translateZ(160px) md:translateZ(190px) lg:translateZ(240px)" }}>
              <div className="relative w-full h-full bg-gradient-to-br from-slate-800/40 via-blue-800/40 to-emerald-800/40 backdrop-blur-xl rounded-[30px] sm:rounded-[35px] md:rounded-[40px] border-2 border-white/30 shadow-2xl flex items-center justify-center overflow-hidden p-4 sm:p-5 md:p-6">
                <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(16,185,129,0.1)_0%,transparent_80%)]" />

                <div className="relative z-10 text-center w-full">
                  <motion.h3
                    className="text-xl sm:text-2xl md:text-3xl font-bold mb-2 sm:mb-3 md:mb-4 bg-gradient-to-r from-emerald-400 to-blue-400 bg-clip-text text-transparent"
                    animate={{ scale: [1, 1.05, 1] }}
                    transition={{ duration: 3, repeat: Infinity }}
                  >
                    Let's Connect
                  </motion.h3>

                  <div className="space-y-2 sm:space-y-3">
                    {[
                      { icon: '📧', text: 'momin@devstack.com' },
                      { icon: '📱', text: '+92 311 2891862' },
                      { icon: '💬', text: 'Available for work' }
                    ].map((item, i) => (
                      <motion.div
                        key={item.text}
                        className="flex items-center gap-2 sm:gap-3 bg-white/10 backdrop-blur-sm rounded-lg sm:rounded-xl p-2 sm:p-3 border border-white/20"
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: i * 0.1 }}
                        whileHover={{ scale: 1.02 }}
                      >
                        <span className="text-xl sm:text-2xl">{item.icon}</span>
                        <span className="text-white text-xs sm:text-sm md:text-base truncate">{item.text}</span>
                      </motion.div>
                    ))}
                  </div>
                </div>
              </div>
            </div> */}
          </motion.div>

          {/* Floating decorative elements - scaled down for mobile */}
          <motion.div
            className="absolute -top-4 sm:-top-6 md:-top-8 -right-4 sm:-right-6 md:-right-8 w-10 sm:w-12 md:w-16 h-10 sm:h-12 md:h-16 bg-gradient-to-r from-emerald-500 to-blue-500 rounded-xl sm:rounded-2xl shadow-2xl flex items-center justify-center border-2 border-white/30"
            animate={{
              y: [0, -15, 0],
              rotate: [0, 15, 0],
              scale: [1, 1.1, 1],
            }}
            transition={{ duration: 4, repeat: Infinity }}
          >
            <span className="text-white text-lg sm:text-xl md:text-2xl">⚡</span>
          </motion.div>

          <motion.div
            className="absolute -bottom-4 sm:-bottom-6 md:-bottom-8 -left-4 sm:-left-6 md:-left-8 w-10 sm:w-12 md:w-16 h-10 sm:h-12 md:h-16 bg-gradient-to-r from-blue-500 to-emerald-400 rounded-xl sm:rounded-2xl shadow-2xl flex items-center justify-center border-2 border-white/30"
            animate={{
              y: [0, 15, 0],
              rotate: [0, -15, 0],
              scale: [1, 1.1, 1],
            }}
            transition={{ duration: 4, repeat: Infinity, delay: 1 }}
          >
            <span className="text-white text-lg sm:text-xl md:text-2xl">💻</span>
          </motion.div>

          {/* Orbiting icons - scaled down for mobile */}
          {/* {['🚀', '💡', '✨', '🌟'].map((icon, i) => (
            <motion.div
              key={i}
              className="absolute w-6 sm:w-8 md:w-10 h-6 sm:h-8 md:h-10 bg-gradient-to-r from-emerald-500/50 to-blue-500/50 backdrop-blur-sm rounded-lg sm:rounded-xl flex items-center justify-center border border-white/30 text-sm sm:text-base md:text-xl"
              animate={{
                rotate: [0, 360],
                x: [0, Math.cos(i * 90) * 100, 0],
                y: [0, Math.sin(i * 90) * 100, 0],
              }}
              transition={{
                duration: 15,
                repeat: Infinity,
                delay: i * 2,
                ease: "linear",
              }}
            >
              {icon}
            </motion.div>
          ))} */}

          {/* const icons = [
          <SiReact />,
          <SiJavascript />,
          <SiTypescript />,
          <SiNextdotjs />,
          ]; */}

          {
            [
              Rocket,
              Lightbulb,
              Sparkles,
              Stars,
            ].map((Icon, i) => (
              <motion.div
                key={i}
                className="absolute w-6 sm:w-8 md:w-10 h-6 sm:h-8 md:h-10 bg-gradient-to-r from-emerald-500/50 to-blue-500/50 backdrop-blur-sm rounded-lg sm:rounded-xl flex items-center justify-center border border-white/30"
                animate={{
                  rotate: [0, 360],
                  x: [0, Math.cos(i * 90) * 100, 0],
                  y: [0, Math.sin(i * 90) * 100, 0],
                }}
                transition={{
                  duration: 15,
                  repeat: Infinity,
                  delay: i * 2,
                  ease: "linear",
                }}
              >
                <Icon
                  className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-white"
                  strokeWidth={2}
                />
              </motion.div>
            ))}

          {/* Floating particles - fewer on mobile */}
          {[...Array(6)].map((_, i) => (
            <motion.div
              key={i}
              className="absolute w-0.5 sm:w-1 h-0.5 sm:h-1 rounded-full"
              style={{
                background: i % 2 === 0 ? '#10B981' : '#3B82F6',
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
              }}
              animate={{
                y: [0, -30, 0],
                x: [0, i % 2 === 0 ? 20 : -20, 0],
                scale: [0, 1, 0],
                opacity: [0, 1, 0],
              }}
              transition={{
                duration: 3 + i,
                repeat: Infinity,
                delay: i * 0.2,
              }}
            />
          ))}
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
          <motion.div
            className="w-1 h-3 bg-white rounded-full mt-2"
            animate={{ y: [0, 12, 0] }}
            transition={{ duration: 2, repeat: Infinity }}
          />
        </div>
      </motion.div>

      <style jsx>{`
        .perspective-1000 {
          perspective: 1000px;
        }
        .backface-hidden {
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
        }
        .bg-grid-pattern {
          background-image: linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
          background-size: 50px 50px;
        }
        .animate-gradient {
          background-size: 200% auto;
          animation: gradient 3s linear infinite;
        }
        @keyframes gradient {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }
      `}</style>
    </section>
  );
};

// import { useEffect, useState } from "react";
// import { motion } from "framer-motion";
// import { Code, Smartphone, Globe, Zap, ArrowRight, MessageCircle } from "lucide-react";

// export const HeroSection = () => {
//   const [isHovered, setIsHovered] = useState(false);
//   const [rotation, setRotation] = useState({ x: 0, y: 0 });
//   const [currentFace, setCurrentFace] = useState(0); // 0: front, 1: right, 2: back, 3: left

//   // Auto-rotate every 5 seconds
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentFace((prev) => (prev + 1) % 4);
//     }, 5000);

//     return () => clearInterval(interval);
//   }, []);

//   // Update rotation based on current face
//   useEffect(() => {
//     switch (currentFace) {
//       case 0: // Front face
//         setRotation({ x: 0, y: 0 });
//         break;
//       case 1: // Right face
//         setRotation({ x: 0, y: 90 });
//         break;
//       case 2: // Back face
//         setRotation({ x: 0, y: 180 });
//         break;
//       case 3: // Left face
//         setRotation({ x: 0, y: -90 });
//         break;
//     }
//   }, [currentFace]);

//   return (
//     <section
//       className="relative min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-emerald-900 px-6 md:px-16 text-white flex items-center justify-center overflow-hidden"
//     >
//       {/* Animated background elements */}
//       <div className="absolute inset-0 overflow-hidden">
//         {[...Array(15)].map((_, i) => (
//           <motion.div
//             key={i}
//             className="absolute rounded-full bg-emerald-500/10"
//             style={{
//               top: `${Math.random() * 100}%`,
//               left: `${Math.random() * 100}%`,
//               width: `${Math.random() * 300 + 50}px`,
//               height: `${Math.random() * 300 + 50}px`,
//             }}
//             animate={{
//               scale: [1, 1.2, 1],
//               rotate: [0, 180, 360],
//             }}
//             transition={{
//               duration: Math.random() * 10 + 10,
//               repeat: Infinity,
//               ease: "linear",
//             }}
//           />
//         ))}
//       </div>

//       <div className="relative z-10 max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-16 w-full py-12">
//         {/* Left Text */}
//         <motion.div
//           initial={{ opacity: 0, x: -60 }}
//           whileInView={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.8 }}
//           viewport={{ once: false }}
//           className="text-center md:text-left md:w-1/2"
//         >
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.2, duration: 0.6 }}
//             viewport={{ once: false }}
//             className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6"
//           >
//             <Zap className="w-4 h-4 text-emerald-400" />
//             <span className="text-sm">Full Stack Developer</span>
//           </motion.div>

//           <h1 className="text-5xl md:text-6xl font-bold leading-tight mb-6">
//             Transforming Ideas Into{" "}
//             <span className="bg-gradient-to-r from-emerald-400 to-blue-500 bg-clip-text text-transparent">
//               Digital Excellence
//             </span>
//           </h1>

//           <motion.p
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.4, duration: 0.6 }}
//             viewport={{ once: false }}
//             className="text-lg md:text-xl text-gray-300 max-w-xl mx-auto md:mx-0 mb-8"
//           >
//             Hi, I'm <strong className="text-white">Momin Hussain</strong> – a passionate Full stack web developer crafting high-performance, responsive websites that drive business growth and deliver exceptional user experiences.
//           </motion.p>

//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.6, duration: 0.6 }}
//             viewport={{ once: false }}
//             className="flex flex-wrap justify-center md:justify-start gap-4 mb-10"
//           >
//             {[
//               { icon: <Code className="w-5 h-5" />, text: "Web Development" },
//               { icon: <Smartphone className="w-5 h-5" />, text: "Mobile Responsive" },
//               { icon: <Globe className="w-5 h-5" />, text: "SEO Optimized" },
//             ].map((item, index) => (
//               <div key={index} className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg">
//                 {item.icon}
//                 <span className="text-sm">{item.text}</span>
//               </div>
//             ))}
//           </motion.div>

//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.8, duration: 0.6 }}
//             viewport={{ once: false }}
//             className="flex flex-wrap justify-center md:justify-start gap-4"
//           >
//             <motion.a
//               href="https://wa.me/923112891862?text=Hi%20Momin%2C%20I%20want%20to%20discuss%20a%20project"
//               target="_blank"
//               rel="noopener noreferrer"
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               onMouseEnter={() => setIsHovered(true)}
//               onMouseLeave={() => setIsHovered(false)}
//               className="flex items-center gap-2 bg-gradient-to-r from-blue-600 to-emerald-600 hover:from-blue-700 hover:to-emerald-700 text-white px-8 py-4 rounded-xl shadow-lg hover:shadow-blue-500/30 transition-all duration-300 font-medium"
//             >
//               <MessageCircle className="w-5 h-5" />
//               Start a Conversation
//               <motion.div
//                 animate={{ x: isHovered ? 5 : 0 }}
//                 transition={{ type: "spring", stiffness: 500 }}
//               >
//                 <ArrowRight className="w-5 h-5" />
//               </motion.div>
//             </motion.a>

//             <motion.a
//               href="#portfolio"
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               className="flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-xl border border-white/20 transition-all duration-300 font-medium"
//             >
//               View My Work
//             </motion.a>
//           </motion.div>
//         </motion.div>

//         {/* Right Side - 3D Cube with Auto-rotation */}
//         <motion.div
//           className="relative w-[350px] sm:w-[400px] md:w-[480px] aspect-square mx-auto"
//           initial={{ opacity: 0, x: 60 }}
//           whileInView={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.8, delay: 0.5 }}
//           viewport={{ once: false }}
//           style={{
//             transformStyle: "preserve-3d",
//             perspective: "1200px",
//           }}
//         >
//           {/* Main 3D Cube Container */}
//           <motion.div
//             className="relative w-full h-full"
//             animate={{
//               rotateX: rotation.x,
//               rotateY: rotation.y,
//             }}
//             transition={{ type: "spring", stiffness: 150, damping: 15 }}
//             style={{
//               transformStyle: "preserve-3d",
//             }}
//           >
//             {/* Front Face - Developer Showcase */}
//             <div className="absolute inset-0 backface-hidden">
//               <div className="relative w-full h-full bg-gradient-to-br from-slate-800/40 via-blue-800/40 to-emerald-800/40 backdrop-blur-xl rounded-[40px] border-2 border-white/30 shadow-2xl flex items-center justify-center overflow-hidden">
//                 {/* Content same as before */}
//                 <div className="absolute inset-0">
//                   <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(16,185,129,0.2)_0%,transparent_40%)]" />
//                   <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_80%,rgba(59,130,246,0.2)_0%,transparent_40%)]" />
//                   <div className="absolute inset-0" style={{
//                     backgroundImage: `repeating-linear-gradient(45deg, rgba(255,255,255,0.05) 0px, rgba(255,255,255,0.05) 2px, transparent 2px, transparent 10px)`,
//                   }} />
//                 </div>

//                 {/* Floating orbs */}
//                 <motion.div
//                   className="absolute w-48 h-48 bg-emerald-500/20 rounded-full blur-3xl top-5 left-5"
//                   animate={{ scale: [1, 1.4, 1], x: [0, 30, 0], y: [0, -20, 0] }}
//                   transition={{ duration: 7, repeat: Infinity }}
//                 />
//                 <motion.div
//                   className="absolute w-56 h-56 bg-blue-500/20 rounded-full blur-3xl bottom-5 right-5"
//                   animate={{ scale: [1, 1.5, 1], x: [0, -30, 0], y: [0, 30, 0] }}
//                   transition={{ duration: 8, repeat: Infinity }}
//                 />
//                 <motion.div
//                   className="absolute w-40 h-40 bg-emerald-400/20 rounded-full blur-3xl top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
//                   animate={{ scale: [1, 1.3, 1], opacity: [0.2, 0.5, 0.2] }}
//                   transition={{ duration: 6, repeat: Infinity }}
//                 />

//                 <div className="relative z-20 w-full h-full flex flex-col items-center justify-center p-8">
//                   {/* 3D Rotating Icon Sphere */}
//                   <motion.div
//                     animate={{ rotateY: [0, 360], rotateX: [0, 15, 0, -15, 0] }}
//                     transition={{ rotateY: { duration: 20, repeat: Infinity, ease: "linear" }, rotateX: { duration: 8, repeat: Infinity, ease: "easeInOut" } }}
//                     className="relative mb-6"
//                   >
//                     <div className="absolute inset-0 rounded-full bg-gradient-to-r from-emerald-500 via-blue-500 to-emerald-400 blur-3xl opacity-40" />
//                     <div className="relative w-56 h-56">
//                       <motion.div
//                         className="absolute inset-0 rounded-full border-4 border-transparent"
//                         style={{
//                           background: "linear-gradient(135deg, #10B981, #3B82F6, #10B981)",
//                           WebkitMask: "linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0)",
//                           WebkitMaskComposite: "destination-out",
//                           maskComposite: "exclude",
//                         }}
//                         animate={{ rotate: 360 }}
//                         transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
//                       />
//                       <motion.div
//                         className="absolute inset-3 rounded-full border-2 border-dashed border-white/40"
//                         animate={{ rotate: -360 }}
//                         transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
//                       />
//                       <div className="absolute inset-6 rounded-full bg-gradient-to-br from-emerald-600/20 via-blue-600/20 to-emerald-600/20 backdrop-blur-sm border border-white/30 shadow-xl flex items-center justify-center overflow-hidden">
//                         {[...Array(8)].map((_, i) => (
//                           <motion.div
//                             key={i}
//                             className="absolute w-2 h-2 rounded-full"
//                             style={{ background: i % 2 === 0 ? '#10B981' : '#3B82F6', top: `${Math.random() * 100}%`, left: `${Math.random() * 100}%` }}
//                             animate={{ y: [0, -40, 0], x: [0, i % 2 === 0 ? 20 : -20, 0], opacity: [0, 1, 0], scale: [0, 1.5, 0] }}
//                             transition={{ duration: 3 + i, repeat: Infinity, delay: i * 0.3 }}
//                           />
//                         ))}
//                         <svg viewBox="0 0 120 120" className="w-32 h-32 z-10">
//                           <defs>
//                             <linearGradient id="devGrad" x1="0%" y1="0%" x2="100%" y2="100%">
//                               <stop offset="0%" stopColor="#10B981">
//                                 <animate attributeName="stop-color" values="#10B981; #3B82F6; #10B981" dur="5s" repeatCount="indefinite" />
//                               </stop>
//                               <stop offset="50%" stopColor="#3B82F6">
//                                 <animate attributeName="stop-color" values="#3B82F6; #10B981; #3B82F6" dur="5s" repeatCount="indefinite" />
//                               </stop>
//                               <stop offset="100%" stopColor="#10B981">
//                                 <animate attributeName="stop-color" values="#10B981; #3B82F6; #10B981" dur="5s" repeatCount="indefinite" />
//                               </stop>
//                             </linearGradient>
//                             <filter id="glow">
//                               <feGaussianBlur stdDeviation="3" result="coloredBlur" />
//                               <feMerge>
//                                 <feMergeNode in="coloredBlur" />
//                                 <feMergeNode in="SourceGraphic" />
//                               </feMerge>
//                             </filter>
//                           </defs>
//                           <g filter="url(#glow)">
//                             <circle cx="60" cy="35" r="12" fill="url(#devGrad)" fillOpacity="0.9" />
//                             <rect x="48" y="45" width="24" height="30" fill="url(#devGrad)" fillOpacity="0.7" rx="4" />
//                             <rect x="30" y="75" width="60" height="8" fill="url(#devGrad)" fillOpacity="0.9" rx="2" />
//                             <rect x="35" y="50" width="50" height="30" fill="none" stroke="url(#devGrad)" strokeWidth="3" rx="3" />
//                             <line x1="45" y1="62" x2="75" y2="62" stroke="white" strokeWidth="2" strokeLinecap="round">
//                               <animate attributeName="x2" values="75;70;75" dur="2s" repeatCount="indefinite" />
//                             </line>
//                             <line x1="45" y1="68" x2="65" y2="68" stroke="white" strokeWidth="2" strokeLinecap="round">
//                               <animate attributeName="x2" values="65;60;65" dur="2s" repeatCount="indefinite" begin="0.5s" />
//                             </line>
//                             <line x1="45" y1="74" x2="55" y2="74" stroke="white" strokeWidth="2" strokeLinecap="round">
//                               <animate attributeName="x2" values="55;50;55" dur="2s" repeatCount="indefinite" begin="1s" />
//                             </line>
//                             <text x="15" y="25" fill="white" fontSize="12" opacity="0.7">&lt;/&gt;</text>
//                             <text x="90" y="90" fill="white" fontSize="12" opacity="0.7">{'{ }'}</text>
//                           </g>
//                         </svg>
//                       </div>
//                     </div>
//                   </motion.div>

//                   <motion.h3 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }} className="text-3xl font-black mb-1 text-center">
//                     <span className="bg-gradient-to-r from-emerald-400 via-blue-400 to-emerald-400 bg-clip-text text-transparent bg-[length:200%_auto] animate-gradient">Momin Hussain</span>
//                   </motion.h3>
//                   <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.4 }} className="text-xl font-medium text-white/90 mb-4">Full Stack Developer</motion.p>
//                   <motion.div className="flex flex-wrap justify-center gap-2" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5 }}>
//                     {[
//                       { name: 'React', color: 'from-emerald-400 to-emerald-500' },
//                       { name: 'Node.js', color: 'from-emerald-500 to-green-500' },
//                       { name: 'Python', color: 'from-blue-400 to-blue-500' },
//                       { name: 'TypeScript', color: 'from-emerald-500 to-blue-500' },
//                       { name: 'Next.js', color: 'from-gray-700 to-gray-900' },
//                       { name: 'MongoDB', color: 'from-emerald-500 to-teal-500' }
//                     ].map((tech, i) => (
//                       <motion.span key={tech.name} className={`px-3 py-1.5 bg-gradient-to-r ${tech.color} text-white text-xs font-semibold rounded-full shadow-lg`} initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 0.6 + i * 0.1, type: "spring" }} whileHover={{ scale: 1.1, y: -2 }}>{tech.name}</motion.span>
//                     ))}
//                   </motion.div>
//                   <motion.div className="flex items-center gap-4 mt-5" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.8 }}>
//                     <div className="flex items-center gap-1">
//                       {[1, 2, 3, 4, 5].map((star) => (
//                         <motion.svg key={star} className="w-4 h-4 text-emerald-400" fill="currentColor" viewBox="0 0 20 20" initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 0.9 + star * 0.1 }}>
//                           <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//                         </motion.svg>
//                       ))}
//                     </div>
//                     <span className="text-white/80 text-sm">5+ Years Experience</span>
//                   </motion.div>
//                 </div>
//               </div>
//             </div>

//             {/* Back Face - Skills */}
//             <div className="absolute inset-0 backface-hidden" style={{ transform: "rotateY(180deg)" }}>
//               <div className="relative w-full h-full bg-gradient-to-br from-slate-800/40 via-blue-800/40 to-emerald-800/40 backdrop-blur-xl rounded-[40px] border-2 border-white/30 shadow-2xl flex items-center justify-center overflow-hidden p-6">
//                 <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(16,185,129,0.1)_0%,transparent_70%)]" />
//                 <div className="relative z-10 text-center">
//                   <motion.h3 className="text-3xl font-bold mb-4 bg-gradient-to-r from-emerald-400 to-blue-400 bg-clip-text text-transparent" animate={{ scale: [1, 1.05, 1] }} transition={{ duration: 3, repeat: Infinity }}>Skills & Expertise</motion.h3>
//                   <div className="grid grid-cols-2 gap-3">
//                     {[
//                       { name: 'Frontend', level: 95 },
//                       { name: 'Backend', level: 90 },
//                       { name: 'Database', level: 85 },
//                       { name: 'DevOps', level: 80 },
//                       { name: 'UI/UX', level: 88 },
//                       { name: 'Mobile', level: 82 }
//                     ].map((skill, i) => (
//                       <motion.div key={skill.name} className="bg-white/10 backdrop-blur-sm rounded-xl p-3 border border-white/20" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.1 }}>
//                         <div className="text-white font-medium mb-1">{skill.name}</div>
//                         <div className="w-full bg-white/20 rounded-full h-2">
//                           <motion.div className="h-full rounded-full bg-gradient-to-r from-emerald-400 to-blue-400" initial={{ width: 0 }} animate={{ width: `${skill.level}%` }} transition={{ delay: 0.5 + i * 0.1, duration: 1 }} />
//                         </div>
//                       </motion.div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Right Face - Projects */}
//             <div className="absolute inset-0 backface-hidden" style={{ transform: "rotateY(90deg) translateZ(240px)" }}>
//               <div className="relative w-full h-full bg-gradient-to-br from-slate-800/40 via-blue-800/40 to-emerald-800/40 backdrop-blur-xl rounded-[40px] border-2 border-white/30 shadow-2xl flex items-center justify-center overflow-hidden p-6">
//                 <div className="absolute inset-0 bg-[conic-gradient(from_0deg,rgba(16,185,129,0.05)_0deg,transparent_120deg)]" />
//                 <div className="relative z-10 text-center">
//                   <motion.h3 className="text-3xl font-bold mb-4 bg-gradient-to-r from-emerald-400 to-blue-400 bg-clip-text text-transparent" animate={{ scale: [1, 1.05, 1] }} transition={{ duration: 3, repeat: Infinity }}>Recent Projects</motion.h3>
//                   <div className="space-y-3">
//                     {[
//                       { name: 'E-Commerce Platform', tech: 'React, Node.js, MongoDB' },
//                       { name: 'AI Analytics Dashboard', tech: 'Python, TensorFlow, Next.js' },
//                       { name: 'Mobile Banking App', tech: 'React Native, Node.js' }
//                     ].map((project, i) => (
//                       <motion.div key={project.name} className="bg-white/10 backdrop-blur-sm rounded-xl p-3 border border-white/20 text-left" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.1 }} whileHover={{ scale: 1.02, backgroundColor: 'rgba(255,255,255,0.2)' }}>
//                         <div className="text-white font-semibold">{project.name}</div>
//                         <div className="text-white/60 text-sm">{project.tech}</div>
//                       </motion.div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Left Face - Contact */}
//             <div className="absolute inset-0 backface-hidden" style={{ transform: "rotateY(-90deg) translateZ(240px)" }}>
//               <div className="relative w-full h-full bg-gradient-to-br from-slate-800/40 via-blue-800/40 to-emerald-800/40 backdrop-blur-xl rounded-[40px] border-2 border-white/30 shadow-2xl flex items-center justify-center overflow-hidden p-6">
//                 <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(16,185,129,0.1)_0%,transparent_80%)]" />
//                 <div className="relative z-10 text-center">
//                   <motion.h3 className="text-3xl font-bold mb-4 bg-gradient-to-r from-emerald-400 to-blue-400 bg-clip-text text-transparent" animate={{ scale: [1, 1.05, 1] }} transition={{ duration: 3, repeat: Infinity }}>Let's Connect</motion.h3>
//                   <div className="space-y-3">
//                     {[
//                       { icon: '📧', text: 'momin@devstack.com' },
//                       { icon: '📱', text: '+92 311 2891862' },
//                       { icon: '💬', text: 'Available for work' }
//                     ].map((item, i) => (
//                       <motion.div key={item.text} className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-xl p-3 border border-white/20" initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.1 }} whileHover={{ scale: 1.02 }}>
//                         <span className="text-2xl">{item.icon}</span>
//                         <span className="text-white">{item.text}</span>
//                       </motion.div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </motion.div>

//           {/* Floating decorative elements (unchanged) */}
//           <motion.div className="absolute -top-8 -right-8 w-16 h-16 bg-gradient-to-r from-emerald-500 to-blue-500 rounded-2xl shadow-2xl flex items-center justify-center border-2 border-white/30" animate={{ y: [0, -15, 0], rotate: [0, 15, 0], scale: [1, 1.1, 1] }} transition={{ duration: 4, repeat: Infinity }}>
//             <span className="text-white text-2xl">⚡</span>
//           </motion.div>
//           <motion.div className="absolute -bottom-8 -left-8 w-16 h-16 bg-gradient-to-r from-blue-500 to-emerald-400 rounded-2xl shadow-2xl flex items-center justify-center border-2 border-white/30" animate={{ y: [0, 15, 0], rotate: [0, -15, 0], scale: [1, 1.1, 1] }} transition={{ duration: 4, repeat: Infinity, delay: 1 }}>
//             <span className="text-white text-2xl">💻</span>
//           </motion.div>
//           {['🚀', '💡', '✨', '🌟'].map((icon, i) => (
//             <motion.div key={i} className="absolute w-10 h-10 bg-gradient-to-r from-emerald-500/50 to-blue-500/50 backdrop-blur-sm rounded-xl flex items-center justify-center border border-white/30 text-xl" animate={{ rotate: [0, 360], x: [0, Math.cos(i * 90) * 180, 0], y: [0, Math.sin(i * 90) * 180, 0] }} transition={{ duration: 15, repeat: Infinity, delay: i * 2, ease: "linear" }}>
//               {icon}
//             </motion.div>
//           ))}
//           {[...Array(10)].map((_, i) => (
//             <motion.div key={i} className="absolute w-1 h-1 rounded-full" style={{ background: i % 2 === 0 ? '#10B981' : '#3B82F6', top: `${Math.random() * 100}%`, left: `${Math.random() * 100}%` }} animate={{ y: [0, -30, 0], x: [0, i % 2 === 0 ? 20 : -20, 0], scale: [0, 1, 0], opacity: [0, 1, 0] }} transition={{ duration: 3 + i, repeat: Infinity, delay: i * 0.2 }} />
//           ))}
//         </motion.div>
//       </div>

//       {/* Scroll indicator */}
//       <motion.div className="absolute bottom-8 left-1/2 transform -translate-x-1/2" animate={{ y: [0, 10, 0] }} transition={{ duration: 2, repeat: Infinity }}>
//         <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
//           <motion.div className="w-1 h-3 bg-white rounded-full mt-2" animate={{ y: [0, 12, 0] }} transition={{ duration: 2, repeat: Infinity }} />
//         </div>
//       </motion.div>

//       <style jsx>{`
//         .perspective-1000 { perspective: 1000px; }
//         .backface-hidden { backface-visibility: hidden; -webkit-backface-visibility: hidden; }
//         .bg-grid-pattern {
//           background-image: linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px),
//             linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px);
//           background-size: 50px 50px;
//         }
//         .animate-gradient { background-size: 200% auto; animation: gradient 3s linear infinite; }
//         @keyframes gradient { 0% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } 100% { background-position: 0% 50%; } }
//       `}</style>
//     </section>
//   );
// };